<template>
    <div class="engagements">
        <div class="content">
            <div class="wrapper">
                <div class="wrap">
                    <div class="wrap__tree" ref="wrap__tree">
                <div class="nav-project">
                    <div class="nav-project_first-row" style="width: 100%;">
                        <div v-if="!isWorkDay" id="fade-in" style="width: 100%;">
                          <div style="display: flex; width: 100%; align-items: flex-end">
<!--                            <el-tooltip-->
<!--                                v-if="rowData.length"-->
<!--                                effect="dark"-->
<!--                                placement="bottom-start">-->
<!--                              <div slot="content" class="engagement-tooltip-content">-->
<!--                                <div class="engagement-tooltip-item">-->
<!--                                  {{$t('modal_engagementName')}}:<span>{{rowData[0].name}}</span>-->
<!--                                </div>-->
<!--                                <div class="engagement-tooltip-item">-->
<!--                                  {{$t('modal_engagementOwner')}}:<span>{{rowData[0].engagementOwner}}</span>-->
<!--                                </div>-->
<!--                                <div class="engagement-tooltip-item">-->
<!--                                  {{$t('modal_stage')}}:<span>{{rowData[0].engagementStage}}</span>-->
<!--                                </div>-->
<!--                                <div class="engagement-tooltip-item">-->
<!--                                  {{$t('modal_no')}}:<span>{{rowData[0].code}}</span>-->
<!--                                </div>-->
<!--                                <div class="engagement-tooltip-item">-->
<!--                                  {{$t('general_leader')}}:<span>{{rowData[0].leader.fullName}}</span>-->
<!--                                </div>-->
<!--                                <div class="engagement-tooltip-item">-->
<!--                                  {{$t('general_supportsBus')}}:<span>{{rowData[0].buManager.join(', ')}}</span>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              <el-button-->
<!--                                  size="small"-->
<!--                                  icon="el-icon-edit-outline">-->
<!--                                {{$t('engagement_info')}}-->
<!--                              </el-button>-->
<!--                            </el-tooltip>-->
                            <el-dropdown v-if="rowData.length" size="medium" >
                              <el-button
                                size="small"
                                icon="el-icon-edit-outline">
                                {{$t('engagement_info')}}
                              </el-button>
                              <el-dropdown-menu slot="dropdown" class="engagement-info-menu">
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_engagementName')}}:<span>{{rowData[0].name}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_engagementNo')}}:<span>{{rowData[0].code}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_engagementRegion')}}:<span>{{rowData[0].engagementRegion}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_stage')}}:<span>{{rowData[0].engagementStage}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="rowData[0].status">
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_engagementStatus')}}:<span>{{rowData[0].status.name}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item v-if="rowData[0].priority">
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_engagementPriority')}}:<span>{{rowData[0].priority.name}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('modal_engagementOwner')}}:<span>{{rowData[0].engagementOwner}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('general_leader')}}:<span>{{rowData[0].leader.fullName}}</span>
                                  </div>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <div class="engagement-tooltip-item">
                                    {{$t('general_supportsBus')}}:<span>{{rowData[0].buManager.join(', ')}}</span>
                                  </div>
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                            <engagement-search-component
                                style="margin-left: 20px; margin-right: 20px;"
                                ref="engagementSearchComponent"
                                @submit="putEngagementIntoTable"/>
                          </div>
<!--                            <el-select class="inputs" no-data-text="no date" v-model="clientListId" :placeholder="$t('engagement_select_clients')" size="mini">-->
<!--                                <el-option-->
<!--                                        v-for="item in clientList"-->
<!--                                        :key="item.id"-->
<!--                                        :label="item.name"-->
<!--                                        :value="item.id"-->
<!--                                        @click.native="setValueEngagements(item.id)">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                            <el-select class="inputs" no-data-text="no date" v-model="valueEngagement" :placeholder="$t('engagement_select_engagements')" size="mini">-->
<!--                                <el-option-->
<!--                                        v-for="item in engagements"-->
<!--                                        :key="item.id"-->
<!--                                        :label="item.name"-->
<!--                                        :value="item.id"-->
<!--                                        @click.native="setEngagementRowDataInput(item.id, 'first')">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
                            <!--<button @click="testing">clicl</button>-->
                        </div>
                        <div v-if="isWorkDay" class="work-day-block">
                            <el-button class="close-work-day-btn" @click="closeMyWorkDay" size="mini" border type="primary" plain>{{$t('engagement_btn_close_my_workday')}}</el-button>
                            <router-link :to="`/users?companyId=${this.$route.query.companyId}`">
                                <el-button @click="setMyWorkDay" size="mini" type="primary" plain>{{$t('engagement_btn_set_my_workday')}}</el-button>
                            </router-link>
                        </div>
                </div>
                    <el-dropdown @command="handleCommand">
                        <el-button class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('engagement_dropdown_action')}}</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <!--<el-dropdown-item command="changeWorkDay" :disabled="isWorkDay || !engagementPermission.actionMyWorkday" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-tickets">{{$t('engagement_dropdown_action_my_workday')}}</el-dropdown-item>-->
                            <!--<el-dropdown-item v-if="companyLayout" command="addEngagement" :disabled="isWorkDay || !companyLayout.permission.addEngagements" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('engagement_dropdown_action_create_engagement')}}</el-dropdown-item>-->
                            <el-dropdown-item v-if="selectedRow.type === 'Engagement' && companyLayout" command="editEngagement" :disabled="isWorkDay && !companyLayout.permission.updateEngagements" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('engagement_dropdown_action_edit_engagement')}}</el-dropdown-item>
                            <el-dropdown-item v-if="selectedRow.type === 'Engagement' && companyLayout" command="removeBUEngagement" :disabled="isWorkDay && !companyLayout.permission.updateEngagements" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('engagement_dropdown_action_remove_BU_engagement')}}</el-dropdown-item>
                            <el-dropdown-item v-if="companyLayout" command="deleteEngagement" :disabled="isWorkDay && !companyLayout.permission.deleteEngagements" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-delete" v-show="selectedRow.type === 'Engagement' && rowData.length > 0">{{$t('engagement_dropdown_action_deleteEngagement')}}</el-dropdown-item>
                            <el-dropdown-item command="addTask" :disabled="disabledBtn || isWorkDay || !engagementPermission.createTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('engagement_dropdown_action_add_task')}}</el-dropdown-item>
                            <el-dropdown-item command="duplicateTask" :disabled="disabledBtn || isWorkDay || !engagementPermission.createTask" v-show="selectedRow.type !== 'Engagement'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('engagement_dropdown_action_duplicate_task')}}</el-dropdown-item>
                            <el-dropdown-item command="editTask" :disabled="disabledBtn || isWorkDay || !engagementPermission.updateTask" v-show="selectedRow.type !== 'Engagement'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('engagement_dropdown_action_edit_task')}}</el-dropdown-item>
                            <el-dropdown-item command="deleteTask" :disabled="disabledBtn || isWorkDay || !engagementPermission.deleteTask" v-show="selectedRow.type !== 'Engagement'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-delete">{{$t('engagement_dropdown_action_delete_task')}}</el-dropdown-item>
                            <el-dropdown-item v-if="companyLayout" :disabled="disabledBtn || isWorkDay  || !engagementPermission.actionSaveTree" command="saveTaskTree" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-star-off">{{$t('engagement_dropdown_action_save_engagement_tree')}}</el-dropdown-item>
                            <el-dropdown-item command="inviteUser" :disabled="disabledBtn || !companyLayout.permission.inviteUser" v-show="selectedRow.type !== 'Engagement'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('engagement_dropdown_action_inviteUser')}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                      <div style="width:100%; height: calc(100% - 113px); position: relative;">
                        <span v-if="!isWorkDay" class="collapse-btn" @click="expandAll">{{expand ? $t('engagement_closeAllTasks') : $t('engagement_showAllTasks')}}</span>
                        <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" id="myGrid"
                                     :gridOptions="gridOptions"
                                     @grid-ready="onGridReady"
                                     :columnDefs="columnDefs"
                                     :rowData="rowData"
                                     :defaultColDef="defaultColDef"
                                     :components="components"
                                     :treeData="true"
                                     :animateRows="true"
                                     :groupDefaultExpanded="groupDefaultExpanded"
                                     :getDataPath="getDataPath"
                                     :getRowNodeId="getRowNodeId"
                                     :autoGroupColumnDef="autoGroupColumnDef"
                                     :getRowHeight="getRowHeight"
                                     :frameworkComponents="frameworkComponents"
                                     :getContextMenuItems="getContextMenuItems"
                                     @row-drag-move="onRowDragMove"
                                     @row-drag-leave="onRowDragLeave"
                                     @row-drag-end="onRowDragEnd"
                                     :rowSelection="rowSelection"
                                     @selection-changed="onSelectionChanged"
                                     :floatingFilter="true"
                                     :suppressHorizontalScroll="true"
                                     :rowClassRules="rowClassRules"></ag-grid-vue>
                        </div>
                    </div>
                    <!--{{activeTab}}-->
                    <!--{{activeInfoTaskTab}}-->
                    <!--{{activeCRMTab}}-->
                    <!--{{activeSCMTab}}-->
                    <!--{{activeAccountTHINKTab}}-->
                    <!--{{documentList}}-->
                    <div class="wrap__info">
                        <div class="nav-project">
                          <div>
                            <el-dropdown placement="bottom-start" @command="handleCommand">
                                <el-button style="margin-right: 20px;" class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('engagement_dropdown_function')}}</el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :disabled="selectedRow.type !== 'Engagement'" command="toggleEngagementBookmark" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_engagementBookmark')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionCreateEstimate || true" command="createEngagementEstimate" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_create_estimate')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionCreateQuotation || true" command="createEngagementQuotation" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_create_quotation')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionCreateSalesOrder || true" command="createProjectSalesOrder" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_create_sales_order')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionCreateInvoice || true" command="createEngagementInvoice" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_create_invoice')}}</el-dropdown-item>

                                    <el-dropdown-item :disabled="!engagementPermission.functionRequestPurchase || true" command="purchaseRequest" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_purchase_request')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionAddPayment || true" command="addEngagementPayment" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_add_payment')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionCreateCreditNote || true" command="createEngagementCreditNote" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_create_credit_note')}}</el-dropdown-item>

                                    <el-dropdown-item :disabled="!isEngagement || !engagementPermission.functionAddExpense || true" command="addEngagementExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_add_expense')}}</el-dropdown-item>
                                    <!--tasks-->
                                    <el-dropdown-item :disabled="isEngagement" command="toggleEngagementTaskBookmark" divided class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_bookmarkTask')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionCreateTaskEstimate || true" command="createTaskEstimate" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_create_task_estimate')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="!engagementPermission.functionRequestCashAdvance || true" command="createCashAdvance" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_request_cash_advance')}}</el-dropdown-item>
                                    <el-dropdown-item :disabled="isEngagement || !engagementPermission.functionAddTaskExpense || true" command="addTaskExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_add_task_expense')}}</el-dropdown-item>
                                    <el-dropdown-item command="addTaskTimer" :disabled="isEngagement || selectedRow.type !== 'Task' || (selectedRow.taskStatus !== 2 && selectedRow.taskStatus !== 5) || !engagementPermission.functionStartTaskTimer" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('engagement_dropdown_function_start_task_timer')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-button :disabled="!engagementPermission.functionCalander || !$route.query.engagementId" @click="openScheduler" style="margin-right: 10px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('engagement_btn_calander')}}</el-button>
                            <!--<el-button :disabled="!engagementPermission.functionCharts" @click="underDevelopment" style="margin-right: 10px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('engagement_btn_gant')}}</el-button>-->
                            <el-button :disabled="!engagementPermission.functionReports" @click="underDevelopment" style="margin-right: 10px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('engagement_btn_reports')}}</el-button>
                          </div>
                        </div>
                        <el-tabs type="border-card" v-model="activeTab" @tab-click="handleClick">
                            <el-tab-pane v-if="isEngagement" :disabled="disabledBtn || !engagementPermission.viewInfo" :label="$t('e_tab_info')" name="first">
                                <InfoTab ref="infoTab"
                                         :companyLayout="companyLayout"
                                         v-if="!disabledBtn"
                                         v-model="activeInfoTab"
                                         :projectInfo="projectInfo"
                                         :bookmarkListEngagement="bookmarkListEngagement"
                                         :selectedRow="selectedRow"
                                         @setNewPermissions="setNewPermissions"
                                         :engagementPermission="engagementPermission"
                                />

                            </el-tab-pane>
                            <el-tab-pane v-else :disabled="disabledBtn || !engagementPermission.viewTaskInfo" :label="$t('e_tab_info')" name="taskInfoTab">
                                <InfoTaskTab ref="taskInfoTab"
                                         v-if="!disabledBtn"
                                         v-model="activeInfoTaskTab"
                                         :bookmarkList="bookmarkList"
                                         :taskInfo="taskInfo"
                                         :selectedRow="selectedRow"
                                         :engagementPermission="engagementPermission"

                                         :progressData="progressData"
                                         :selectedTaskForInfo="selectedTaskForInfo"
                                         :selectedRowId="selectedRow.id"
                                         :activeEngagementId="activeEngagementId"
                                         @getProjects="setEngagementRowDataInput"
                                />

                            </el-tab-pane>
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewFiles" v-if="isEngagement" :label="$t('e_tab_files')" name="third">
                                <EngagementsFilesTabNew
                                        :engagementPermission="engagementPermission"
                                        :selectedRow="selectedRow"
                                        :bookmarkListEngagement="bookmarkListEngagement"
                                        v-if="!disabledBtn" />
                            </el-tab-pane>
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewTaskFiles" v-else :label="$t('e_tab_files')" name="four">
                                <taskFilesTabNew
                                        :engagementPermission="engagementPermission"
                                        :bookmarkList="bookmarkList"
                                        v-if="!disabledBtn"
                                        :selectedRow="selectedRow" />
                            </el-tab-pane>
                            <!-- v-if="selectedRow.type === 'Task' && selectedRow.isReoccuring === 1 || selectedRow.type === 'Task' && selectedRow.hasProgress === 1" -->
                            <el-tab-pane :disabled="disabledBtn" v-if="false" :label="$t('e_tab_progress')" name="second">
                                <EngagementProgressTab
                                        v-if="!disabledBtn"
                                        :bookmarkList="bookmarkList"
                                        :selectedRow="selectedRow"
                                        :progressData="progressData"
                                        :selectedTaskForInfo="selectedTaskForInfo"
                                        :selectedRowId="selectedRow.id"
                                        :engagementPermission="engagementPermission"
                                        @submit="setEngagementRowDataInput" />
                            </el-tab-pane>
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewComments" v-if="isEngagement" :label="$t('e_tab_comments')" name="engagementCommentTab">
                                <engagementCommentsTab ref="engagementCommentTab" :engagementPermission="engagementPermission" :bookmarkListEngagement="bookmarkListEngagement" :selectedRow="selectedRow" v-if="!disabledBtn"/>
                            </el-tab-pane>
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewTaskComments" v-else :label="$t('e_tab_comments')" name="engagementTaskCommentTab">
                                <taskCommentsTab
                                        ref="engagementTaskCommentTab"
                                        :bookmarkList="bookmarkList"
                                        :selectedRow="selectedRow"
                                        v-if="!disabledBtn"
                                        :engagementPermission="engagementPermission"/>
                            </el-tab-pane>

                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewMessages" v-if="isEngagement" :label="$t('e_tab_messages')" name="seven">
                                <MessagesProject :bookmarkListProject="bookmarkListEngagement" v-if="!disabledBtn" type="engagement" :selectedRow="selectedRow" ref="MessagesProject" :activeProjectId="activeEngagementId"/>
                            </el-tab-pane>
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewTaskMessages" v-else :label="$t('e_tab_messages')" name="eight">
                                <MessagesTask :bookmarkList="bookmarkList" v-if="!disabledBtn" type="taskEngagement" :selectedRow="selectedRow" ref="MessagesTask" :activeProjectId="activeEngagementId"/>
                            </el-tab-pane>

                            <el-tab-pane v-if="isEngagement" :disabled="disabledBtn || !engagementPermission.viewMeetings" :label="$t('e_tab_meetings')" name="nine">
                                <engagementMeetings
                                        ref="engagementMeetingTab"
                                        :engagementCompanyVendorList="engagementCompanyVendorList"
                                        :engagementCompanyClientList="engagementCompanyClientList"
                                        :engagementPermission="engagementPermission"
                                        :bookmarkListEngagement="bookmarkListEngagement"
                                        :selectedRow="selectedRow" />
                            </el-tab-pane>

                            <el-tab-pane v-else :disabled="disabledBtn || !engagementPermission.viewTaskMeetings" :label="$t('e_tab_meetings')" name="ten">
                                <engagementTaskMeetings
                                        :engagementTaskCompanyVendorPersonList="engagementTaskCompanyVendorPersonList"
                                        :engagementTaskCompanyClientPersonList="engagementTaskCompanyClientPersonList"
                                        ref="engagementTaskMeetingTab"
                                        :engagementPermission="engagementPermission"
                                        :bookmarkList="bookmarkList"
                                        :selectedRow="selectedRow"/>
                            </el-tab-pane>

                            <!-- v-if="!isEngagement" -->
                            <!--<el-tab-pane :disabled="disabledBtn || !engagementPermission.viewDocuments" v-if="false" :label="$t('e_tab_documents')" name="fourteen">-->
                              <!--<DocumentsTask ref="docs" :engagementPermission="engagementPermission" :bookmarkList="bookmarkList" :selectedRow="selectedRow"/>-->
                            <!--</el-tab-pane>-->

                            <!-- CRM -->
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewCRM || !engagementPermission.viewTaskCRM" :label="$t('e_tab_crm')" name="crm">
                              <CRM
                                      v-model="activeCRMTab"
                                      :isEngagement="isEngagement"
                                      :selectedRow="selectedRow"
                                      ref="crm"
                                      :bookmarkList="bookmarkList"
                                      :bookmarkListEngagement="bookmarkListEngagement"
                                      :engagementPermission="engagementPermission"/>
                            </el-tab-pane>

                            <!-- SCM -->
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewSCM || !engagementPermission.viewTaskSCM" :label="$t('e_tab_scm')" name="scm">
                              <SCM
                                      v-model="activeSCMTab"
                                      :isEngagement="isEngagement"
                                      :selectedRow="selectedRow"
                                      ref="scm"
                                      :bookmarkList="bookmarkList"
                                      :bookmarkListEngagement="bookmarkListEngagement"
                                      :engagementPermission="engagementPermission"/>
                            </el-tab-pane>

                            <!-- aTHINK -->
                            <el-tab-pane :disabled="disabledBtn || !engagementPermission.viewAT || !engagementPermission.viewTaskAT" :label="$t('e_tab_at')" name="aTHINK">
                              <aTHINKTab
                                      v-model="activeAccountTHINKTab"
                                      :isEngagement="isEngagement"
                                      :selectedRow="selectedRow"
                                      ref="aTHINK"
                                      :bookmarkList="bookmarkList"
                                      :bookmarkListEngagement="bookmarkListEngagement"
                                      :engagementPermission="engagementPermission"/>
                            </el-tab-pane>

                        </el-tabs>

                    </div>
                    <!-- [Tree info] end -->
                </div>
            </div>
        </div>


        <!-- [ Modal form Create Engagement] start -->
<!--        <addEngagementModal-->
<!--                ref="addEngagement" @submit="addEngagementToRowData"/>-->
        <!-- [ Modal form Create Engagement] end -->

        <!-- [ Modal form Create Engagement] start -->
        <addEngagementModalWizzard
                ref="addEngagement" @permissionsPromptMessage="openPermissionsTab" @submit="addEngagementToRowData"/>
        <!-- [ Modal form Create Engagement] end -->

        <!-- [ Modal form Create Engagement Task] start -->
        <addEngagementTaskModal ref="addEngagementTask" :selectedRow="selectedRow" @submit="setEngagementRowDataInput"/>
        <!-- [ Modal form Create Engagement Task] end -->

        <!-- [ Modal Reassign Tasks start -->
        <ReassignTasksModal
                :selectedRows="selectedRows"
                :activeEngagementId="activeEngagementId"
                ref="ReassignTasksModal"
                @submit="setEngagementRowDataInput"/>
        <!-- [ Modal Reassign Tasks end -->

        <add-users-to-tasks-modal-e-n-g
                :selectedRows="selectedRows"
                :activeEngagementId="activeEngagementId"
                ref="addNewUserToTasksModal"
                @submit="setEngagementRowDataInput"/>
        <!-- [ Modal after drag end ] start-->

      <!--REMOVE BU FROM ENGAGEMENT MODAL-->
      <remove-b-u-from-engagement-modal ref="removeBuFromEngagementModal" @loadList="loadList"/>
      <!--REMOVE BU FROM ENGAGEMENT MODAL-->

      <!--<sweet-modal blocking width="400" ref="dragEnd">-->
            <!--<div class="draggble">-->
                <!--<h1>Action</h1>-->
                <!--<el-button v-if="potentialParent.id !== 0" @click="createParentTask('1')" class="modal__btn btn" type="primary" plain size="mini">Move Task</el-button>-->
                <!--<div><p>or</p></div>-->
                <!--<el-button @click="createParentTask('0')" class="modal__btn btn" type="primary" plain size="mini">Add to parent</el-button>-->
            <!--</div>-->
        <!--</sweet-modal>-->

        <engagementExpenseModal :selectedRow="selectedRow" ref="engagementExpenseModal"/>
        <engagementCashAdvanceModal :selectedRow="selectedRow" ref="engagementCashAdvanceModal"/>
        <!-- [ Modal after drag end ] start-->
        <CreateEngagementTemplate @getTreeScreen="getTreeScreen" ref="modal777"/>

        <!-- [ Modal task not found ] start-->
        <sweet-modal blocking ref="taskNotFound" icon="warning">
            <div class="task-not-found-block">
                <h3>Task has been deleted</h3>
            </div>
        </sweet-modal>
        <!-- [ Modal task not found ] end -->

        <inviteUserModal ref="inviteUserModal"/>

        <!-- document modal -->
        <!--<el-dialog-->
          <!--:title="(documentList.type)"-->
          <!--:visible.sync="dialogVisible"-->
          <!--width="40%"-->
          <!--:before-close="handleClose">-->
          <!--<span>You have documents that require action.</span>-->
          <!--<span slot="footer" class="dialog-footer">-->
            <!--<el-button type="primary" @click="signDocument">Go</el-button>-->
          <!--</span>-->
        <!--</el-dialog>-->

        <sweet-modal blocking ref="addParent" class="modal-parent">
            Task already started, add sub task not permited, do you want to insert task?
            <el-button slot="button" v-on:click="$refs.addParent.close(),  $refs['addEngagementTask'].openModal('insert')">Insert task</el-button>
        </sweet-modal>

        <!-- [ Modal Under Development ] end -->
        <sweet-modal blocking ref="underDevelopment" icon="warning">
            <div class="task-not-found-block">
                <h3>Current Service Under Development</h3>
            </div>
        </sweet-modal>
        <!--<later-document-modal-engagement ref="laterDocumentModal"/>-->
        <later-document-modal ref="laterDocumentModal"/>

        <scheduler-modal ref="schedulerModal"/>
    </div>
</template>

<script>
  import SchedulerModal from "../components/Projects/calendar/SchedulerModal";
  import log from '@/log/log.js'
  import { mapGetters } from 'vuex'
  import html2canvas from "html2canvas"
  import customTooltip from "../components/ag-grid-components/components/customTooltip";
  import engagementMeetings from '@/components/Engagements/engagementMeetings.vue'
  import engagementTaskMeetings from '@/components/Engagements/engagementTaskMeetings.vue'
  // import VueDragResize from 'vue-drag-resize';
  import EngagementsFilesTabNew from '@/components/Engagements/engagementsFilesTabNew.vue';
  import taskFilesTabNew from '@/components/Engagements/taskFilesTabNew.vue';
  import CreateProjectTaskProgressModal from '@/components/Projects/CreateProjectTaskProgressModal.vue';
  import CreateEngagementTemplate from '@/components/Engagements/createEngagementTemplate.vue';
  import InfoTab from '@/components/Engagements/InfoTab.vue'
  import InfoTaskTab from '@/components/Engagements/infoTaskTab.vue'
  import EngagementProgressTab from '@/components/Engagements/EngagementsProgressTab.vue'
  import ReassignTasksModal from '@/components/Engagements/ReassignTasksModal.vue'

  // import addEngagementModal from '@/components/Engagements/CreateEngagementModal.vue'
  import addEngagementModalWizzard from '@/components/Engagements/CreateEngagementModalWizzard.vue'
  import addEngagementTaskModal from '@/components/Engagements/CreateEngagementTaskModal.vue'
  import engagementExpenseModal from '@/components/Projects/projectExpenseModal.vue'
  import engagementCashAdvanceModal from '@/components/Projects/projectCashAdvanceModal.vue'

  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import { AgGridVue } from 'ag-grid-vue';
  import axios from 'axios';
  import { VueEditor } from 'vue2-editor'
  import moment from 'moment'
  import _ from 'lodash';
  import engagementCommentsTab from '@/components/Engagements/engagementCommentsTab.vue'
  import taskCommentsTab from '@/components/Engagements/taskCommentsTab.vue'
  // Messages
  import MessagesProject from '@/components/Projects/messages/MessagesProject.vue'
  import MessagesTask from '@/components/Projects/messages/MessagesTask.vue'
  // History
  import engagementHistory from '@/components/Engagements/engagementHistoryTab.vue'
  import engagementTaskHistory from '@/components/Engagements/engagementTaskHistoryTab.vue'
  // import DocumentsTask from '@/components/Engagements/DocumentsTask.vue'
  import gridMessageBox from '@/components/Projects/gridMessageBox/main.js';

  import inviteUserModal from '@/components/users/inviteUserModal.vue'

  //GRID ICONS
  import empty from "@/assets/img/grid/empty.svg"
  import timer from "@/assets/img/grid/timer.svg"
  import userDefault from '@/assets/img/user-default.jpg'
  import inProgress from "@/assets/img/grid/progress_icn.svg"
  import start from "@/assets/img/grid/start.svg"
  import pause from "@/assets/img/grid/pause.svg"
  import done from "@/assets/img/grid/marked.svg"

  // aTHINKTab
  import aTHINKTab from '@/components/Engagements/accountTHINK/accountTHINK.vue'

  // CRM
  import CRM from '@/components/Engagements/CRM/CRM.vue'

  // SCM
  import SCM from '@/components/Engagements/SCM/SCM.vue'
  // import LaterDocumentModalEngagement from "../components/Engagements/laterDocumentModal/index";
  import LaterDocumentModal from "../components/documents/laterDocumentModal";
  import AddUsersToTasksModalENG from "../components/Engagements/AddUsersToTasksModal";
  import RemoveBUFromEngagementModal from "../components/Engagements/RemoveBUFromEngagement";
  import EngagementSearchComponent from "../components/Engagements/engagementSearchComponent";

  var potentialParent = null;

  function moveToPath(newParentPath, node, allUpdatedNodes) {
    var oldPath = node.data.filePath;
    var fileName = oldPath[oldPath.length - 1];
    var newChildPath = newParentPath.slice();
    newChildPath.push(fileName);
    node.data.filePath = newChildPath;
    allUpdatedNodes.push(node.data);
    if (node.childrenAfterGroup) {
      node.childrenAfterGroup.forEach(function(childNode) {
        moveToPath(newChildPath, childNode, allUpdatedNodes);
      });
    }
  }

  function isSelectionParentOfTarget(selectedNode, targetNode) {
    var children = selectedNode.childrenAfterGroup;
    for (var i = 0; i < children.length; i++) {
      if (targetNode && children[i].key === targetNode.key) return true;
      isSelectionParentOfTarget(children[i], targetNode);
    }
    return false;
  }

  function arePathsEqual(path1, path2) {
    if (path1.length !== path2.length) {
      return false;
    }
    var equal = true;
    path1.forEach(function(item, index) {
      if (path2[index] !== item) {
        equal = false;
      }
    });
    return equal;
  }

  function setPotentialParentForNode(api, overNode) {
    var newPotentialParent;
    if (overNode) {
      newPotentialParent = overNode.data.myType === "folder" ? overNode : overNode.parent;
    } else {
      newPotentialParent = null;
    }
    var alreadySelected = potentialParent === newPotentialParent;
    if (alreadySelected) {
      return;
    }
    var rowsToRefresh = [];
    if (potentialParent) {
      rowsToRefresh.push(potentialParent);
    }
    if (newPotentialParent) {
      rowsToRefresh.push(newPotentialParent);
    }
    potentialParent = newPotentialParent;
    refreshRows(api, rowsToRefresh);
  }

  function refreshRows(api, rowsToRefresh) {
    var params = {
      rowNodes: rowsToRefresh,
      force: true
    };
    api.refreshCells(params);
  }

  function getFileCellRenderer() {
    function FileCellRenderer() {}
    FileCellRenderer.prototype.init = function(params) {
      var tempDiv = document.createElement("div");
      var value = params.value;
      var icon = getFileIcon(params.value);
      tempDiv.innerHTML = icon ? '<i class="' + icon + '"/>' + '<span class="filename">' + value + "</span>" : value;
      this.eGui = tempDiv.firstChild;
    };
    FileCellRenderer.prototype.getGui = function() {
      return this.eGui;
    };
    return FileCellRenderer;
  }

  function getFileIcon(filename) {
    return filename.endsWith(".mp3") || filename.endsWith(".wav")
  }

  function getDateFromTimestamp(timestamp) {
    if (_.isString(timestamp) && timestamp.match(/^[0-9]+$/)) {
      return new Date(parseInt(timestamp));
    }
    if (_.isNumber(timestamp)) {
      return new Date(timestamp);
    }
  }

  function calcProjectProgress(projectTaskList) {
    if (projectTaskList.length == 0) {
      return 100;
    }
    var count = 0;
    var sum = projectTaskList.reduce(function (sumOfElements, item) {
      if (item.parentEngagementTaskId == 0) {
        count++;
        return sumOfElements + parseInt(item.progress);
      }
      return sumOfElements;
    }, 0);
    return Math.round(sum / count);
  }

  function toId(value) {
    if (_.isNumber(value)) {
      return parseInt(value);
    }
    if (_.isNull(value) || _.isUndefined(value)) {
      return 0;
    }
    return 0;
  }
  function buildTree2(engagementTaskList) {
    return new Promise((resolve, reject) => {
      var resultProjectTaskTree = [];
      var todaysdate = moment();
      for (var index = 0; index < engagementTaskList.length; index++) {
        let reoccuringInDays = null;
        // reoccuringStartDate
        if(engagementTaskList[index].isReoccurring){
          const startTask = engagementTaskList[index].reoccuringStartDate
          const todaysdate = moment().format('X');
          const repeatInterval = Number(engagementTaskList[index].repeatTaskInterval)
          const whenTaskStart = moment(startTask, 'X').add(repeatInterval, 'hours').format('LLLL')
          if(repeatInterval <= 24){
            reoccuringInDays = moment.utc(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).format("HH:mm")
          }else if(repeatInterval > 24){
            reoccuringInDays = Math.round(moment.duration(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).asDays())
          }
          if(startTask < Number(todaysdate)){
            reoccuringInDays = null
          }
        }
        let row = {
          id: engagementTaskList[index].id,
          name: engagementTaskList[index].name,
          filePath: [index],
          engagementId:engagementTaskList[index].engagementId,
          orderIndex:engagementTaskList[index].orderIndex + 1,
          progress: Math.floor(engagementTaskList[index].progress),
          hasProgress:engagementTaskList[index].hasProgress,
          timerCount:engagementTaskList[index].timerCount,
          parentEngagementTaskId:engagementTaskList[index].parentEngagementTaskId,
          type: 'Task',
          reoccuring: reoccuringInDays === null ? '' : reoccuringInDays,
          isReoccuring: engagementTaskList[index].isReoccurring,
          taskStatus: engagementTaskList[index].status,
          myType: 'folder'
        };
        resultProjectTaskTree.push(row);
      }
      resolve(resultProjectTaskTree);
    })
  }
  function buildTree(project, projectTaskList, parentEngagementTaskId, filePath) {
    if (!_.isArray(filePath)) {
      filePath = [];
    }
    var resultProjectTaskTree = [];
    if (project) {
      filePath = ['0'];
      resultProjectTaskTree.push({
        id: 0,
        name: project.name,
        engagementId:project.id,
        filePath: filePath,
        // daysTotal: 0,
        // daysRemaning: 0,
        progress: Number(project.progress),
        type: 'Engagement',
        reoccuring: project.repeatTaskInterval,
        orderIndex: 0,
        taskStatus: -1,
        myType: 'folder'
      });
    }
    for (var index = 0; index < projectTaskList.length; index++) {
      if (toId(projectTaskList[index].parentEngagementTaskId) === toId(parentEngagementTaskId)) {
        var newfilePath = filePath.concat([projectTaskList[index].id].toString());
        var childElementList = buildTree(null, projectTaskList, projectTaskList[index].id, newfilePath);
        let reoccuringInDays = null
        // reoccuringStartDate
        if(projectTaskList[index].isReoccurring){
          var startTask = projectTaskList[index].reoccuringStartDate
          // var startTaskForAdd = moment(projectTaskList[index].reoccuringStartDate, 'X')
          var todaysdate = moment().format('X')
          var repeatInterval = Number(projectTaskList[index].repeatTaskInterval)
          var whenTaskStart = moment(startTask, 'X').add(repeatInterval, 'hours').format('LLLL')
          if(repeatInterval <= 24){
            reoccuringInDays = moment.utc(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).format("HH:mm")
            // console.log('repeatInterval HOURS', repeatInterval)
            // console.log('startTask HOURS', startTask)
            // console.log('startTask HOURS', startTask)
            // console.log('todaysdate HOURS', todaysdate)
            // console.log('todaysdate HOURS', todaysdate)
            // console.log('whenTaskStart HOURS', whenTaskStart)
            // console.log('reoccuringInDays', reoccuringInDays)
          }else if(repeatInterval > 24){
            reoccuringInDays = Math.round(moment.duration(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).asDays())
          }
          if(startTask < Number(todaysdate)){
            reoccuringInDays = null
          }
          console.log('hello')
        }
        if (childElementList.length > 0) {
          resultProjectTaskTree.push({
            id: projectTaskList[index].id,
            name: projectTaskList[index].name,
            engagementId:projectTaskList[index].engagementId,
            filePath: newfilePath,
            // daysTotal: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            // daysRemaning: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            progress: Number(projectTaskList[index].progress),
            hasProgress:projectTaskList[index].hasProgress,
            timerCount:projectTaskList[index].timerCount,
            orderIndex:projectTaskList[index].orderIndex,
            parentEngagementTaskId:projectTaskList[index].parentEngagementTaskId,
            type: 'MasterTask',
            reoccuring: reoccuringInDays === null ? '' : reoccuringInDays,
            isReoccuring: projectTaskList[index].isReoccurring,
            taskStatus: projectTaskList[index].status,
            myType: 'folder'
          });
          resultProjectTaskTree = resultProjectTaskTree.concat(childElementList);
        } else {
          resultProjectTaskTree.push({
            id: projectTaskList[index].id,
            name: projectTaskList[index].name,
            filePath: newfilePath,
            engagementId:projectTaskList[index].engagementId,
            // daysTotal: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            // daysRemaning: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            parentEngagementTaskId:projectTaskList[index].parentEngagementTaskId,
            progress: Number(projectTaskList[index].progress),
            hasProgress:projectTaskList[index].hasProgress,
            timerCount:projectTaskList[index].timerCount,
            orderIndex:projectTaskList[index].orderIndex,
            type: 'Task',
            reoccuring: reoccuringInDays === null ? '' : reoccuringInDays,
            isReoccuring: projectTaskList[index].isReoccurring,
            taskStatus: projectTaskList[index].status,
            myType: 'folder'
          });
        }
      }
    }
    for (let i = 0; i < resultProjectTaskTree.length; i++){
      resultProjectTaskTree[i].myIndex = i.toString()
    }
    return resultProjectTaskTree;
  }


  export default {
    name: 'engagements',
    components: {
      EngagementSearchComponent,
      RemoveBUFromEngagementModal,
      AddUsersToTasksModalENG,
      LaterDocumentModal,
      // LaterDocumentModalEngagement,
      engagementMeetings,
      engagementTaskMeetings,
      // VueDragResize,
      VueEditor,
      // Header,
      AgGridVue,
      SweetModal,
      ReassignTasksModal,
      engagementExpenseModal,
      // CreateProjectModal,
      // EngagementsFilesTab,
      EngagementsFilesTabNew,
      taskFilesTabNew,
      CreateProjectTaskProgressModal,
      // addEngagementModal,
      addEngagementModalWizzard,
      addEngagementTaskModal,
      InfoTab,
      gridMessageBox,
      InfoTaskTab,
      EngagementProgressTab,
      CreateEngagementTemplate,
      engagementCommentsTab,
      taskCommentsTab,
      MessagesProject,
      MessagesTask,
      engagementHistory,
      engagementTaskHistory,
      // DocumentsTask,
      inviteUserModal,
      engagementCashAdvanceModal,
      CRM,
      SCM,
      aTHINKTab,
      SchedulerModal,
    },
    create() {

    },
    computed: {
      ...mapGetters([
        'getStateId'
      ]),
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      user() {
        return this.$store.state.user
      },
      engagementCompanyVendorList() {
          return this.projectInfo.engagementCompanyVendorList.length ? this.projectInfo.engagementCompanyVendorList  : []
      },
      engagementCompanyClientList() {
          return this.projectInfo.engagementCompanyClientList.length ? this.projectInfo.engagementCompanyClientList  : []
      },
      engagementTaskCompanyVendorPersonList() {
          return this.taskInfo.engagementTaskCompanyVendorPersonList.length ? this.taskInfo.engagementTaskCompanyVendorPersonList : []
      },
      engagementTaskCompanyClientPersonList() {
          return this.taskInfo.engagementTaskCompanyClientPersonList.length ? this.taskInfo.engagementTaskCompanyClientPersonList : []
      }
    },
    beforeMount() {
      this.gridOptions = {
        suppressCellSelection: true,
        isRowSelectable: function(rowNode) {
          // console.log('rowNode.data.access', rowNode.data.access, rowNode.data.name);
          return rowNode.data.access
        },
        overlayNoRowsTemplate: this.$i18n.t('general_noRowsToShow'),
      };
      this.columnDefs = [
        {
          headerName: "#",
          field: "myIndex",
          tooltipField: "myIndex",
          tooltipComponentParams: { fieldName: "Index" },
          // headerClass: 'header-center',
          width:20,
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          cellRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.myIndex}</span>`
          },
          cellStyle: function(params) {
            if (params.data.id === 0){
              return {'display':'none'}
            }else{
              return {'text-align': 'center; display: flex; justify-content:center;'}
            }
          }
        },
        {
          headerName: '',
          field: "reoccuring",
          width: 20,
          cellRenderer: function(params) {
            if(params.node.data.reoccuring){
              return `<span class="reoccuringRender">${params.node.data.reoccuring}</span>`
            }
          },
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          }
        },
        {
          headerName: "",
          field: "leader",
          // cellRenderer: "avatarRenderer",
          cellRenderer: function(params) {
            if(params.node.data.leader !== null ){
              if(params.node.data.leader.avatarUrl) return `<img class="imageRender" src=${params.node.data.leader.avatarUrl} />`;
              else return `<img class="imageRender" src=${userDefault} />`
            }else {
              return null
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "leader.fullName",
          tooltipComponentParams: { fieldName: "Assigner" },
          width: 12
        },
        {
          headerName: "",
          field: "daysRemaning",
          // cellRenderer: "dayRenderer",
          tooltipField: "daysRemaning",
          tooltipComponentParams: function (params) {
            // console.log('params--', params)
            const rowNode = params.api.getDisplayedRowAtIndex(params.rowIndex);
            // console.log(rowNode)
            if (rowNode.data.type === 'Task') {
              let numb = params.value.toString().match(/\d/g);
              numb = numb.join("");

              if (params.value[0] === '(' && params.value[1] === '+') {
                return { fieldName: `Completed ${numb} Days Late` }
              }

              if (params.value[0] === '(' && params.value[1] === '-') {
                return { fieldName: `Completed ${numb} Days Early` }
              }

              if (params.value === '(0)') {
                return { fieldName: `Completed on Time` }
              }

              if (params.value === '0') {
                return { fieldName: `Due Today` }
              }

              if (params.value[0] === '+') {
                return { fieldName: `Overdue by ${numb} Days` }
              }

              if (params.value.toString() === '1'){
                return { fieldName: `Due in ${numb} Day` }
              }

              else {
                return { fieldName: `Due in ${numb} Days`}
              }
            } else if (rowNode.data.type === 'MasterTask') {
              return {fieldName: `Master Task`}
            }
          },
          cellRenderer: function(params) {
            let deadlineChildTasks = [];
            switch(params.node.data.type) {
              case 'Engagement':
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.daysRemaning) deadlineChildTasks.push(rowNode)
                });
                return `<div class="dayRender">${deadlineChildTasks.length}</div>`
              case 'task' :
              case 'Task' :
                if (!params.value){
                  return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                } else {
                  return `<div class="dayRenderTask">${params.node.data.daysRemaning}</div>`
                }
              case 'MasterTask' :
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.parentBusinessUnitTaskId === params.data.id && rowNode.data.daysRemaning) deadlineChildTasks.push(rowNode)
                });
                return `<div class="dayRender">${deadlineChildTasks.length}</div>`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          width:12
        },
        {
          headerName: "",
          field: "reccuringOverdue",
          // cellRenderer: "dayRenderer",
          tooltipField: "reccuringOverdue",
          tooltipComponentParams: function (params) {
            // console.log('params--', params)
            const rowNode = params.api.getDisplayedRowAtIndex(params.rowIndex);
            // console.log(rowNode)
            if (rowNode.data.type === 'Task') {
              let numb = params.value.toString().match(/\d/g);
              numb = numb.join("");
              console.log('!!! PARAMS !!!', numb)
              console.log('!!! PARAMS !!!', params.value[0])
              // if (params.value[0] === '(' && params.value[1] === '+') {
              //   return { fieldName: `Completed ${numb} Days Late` }
              // }
              //
              // if (params.value[0] === '(' && params.value[1] === '-') {
              //   return { fieldName: `Completed ${numb} Days Early` }
              // }

              // if (params.value === '(0)') {
              //   return { fieldName: `Completed on Time` }
              // }

              if (params.value === '0') {
                return { fieldName: `Recurring Now` }
              }

              if (params.value[0] === '+') {
                return { fieldName: `Overdue by ${numb} Days` }
              }

              if (params.value.toString() === '1'){
                return { fieldName: `Due in ${numb} Day` }
              }

              else {
                return { fieldName: `Recurring in ${numb} (D)`}
              }
            } else if (rowNode.data.type === 'MasterTask') {
              return {fieldName: `Master Task`}
            }
          },
          cellRenderer: function(params) {
            let reccuringChildTasks = [];
            switch(params.node.data.type) {
              case 'Engagement':
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.isReoccurring) reccuringChildTasks.push(rowNode)
                });
                return `<div class="dayRemaningRender">${reccuringChildTasks.length}</div>`
              case 'task' :
              case 'Task' :
                if (!params.node.data.isReoccurring){
                  return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                } else {
                  return `<div class="dayRenderTask">${params.node.data.reccuringOverdue}</div>`
                }
              case 'MasterTask' :
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.parentBusinessUnitTaskId === params.data.id && rowNode.data.isReoccurring) reccuringChildTasks.push(rowNode)
                });
                return `<div class="dayRemaningRender">${reccuringChildTasks.length}</div>`
            }
          },
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          width:12,
        },
        {
          headerName: "",
          field: "taskStatus",
          // cellRenderer: "taskStatusRenderer",
          tooltipField: "taskStatus",
          cellRenderer: function(params) {
            let childTasks = [];
            let doneCount = [];
            // different conditions for task and masterTask
            switch(params.node.data.type){
              case 'Task' :
              case 'task' :
                switch(params.node.data.taskStatus) {
                  // created
                  case 1:
                    return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                  //started
                  case 2:
                    // if in progress
                    if(params.node.data.progress) {
                      return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
                    }else{
                      return `<img v-if="taskStatus" class="imageRender" src=${start} />`

                    }
                  // holded
                  case 3:
                    return `<img v-if="taskStatus" class="imageRender" src=${pause} />`
                  // done
                  case 4:
                    return `<img v-if="taskStatus" class="imageRender" src=${done} />`
                  case 5:
                    return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
                }
                break;
              case 'MasterTask':
                params.api.forEachNode(function(rowNode, index) {
                  let childTask = '';
                  let doneChildTask = '';
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress) {
                    childTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.taskStatus === 4) {
                    doneChildTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if(childTask) childTasks.push(childTask);
                  if(doneChildTask) doneCount.push(doneChildTask)
                });
                // return `<img v-if="taskStatus" class="imageRender" src=${masterTaskIcon} />`
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              case 'Engagement':
                params.api.forEachNode(function(rowNode, index) {
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress){
                    childTasks.push(rowNode.data)
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.taskStatus === 4){
                    doneCount.push(rowNode.data)
                  }
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              // return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipComponentParams: { fieldName: "Task Status" },
          width: 12
        },
        {
          headerName: "",
          field: "progress",
          // cellRenderer: "progressRenderer",
          cellRenderer: function(params) {
            let childTasks = [];
            let doneCount = [];
            switch(params.node.data.type) {
              case 'Engagement' :
                params.api.forEachNode(function(rowNode, index) {
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress){
                    childTasks.push(rowNode.data)
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.progress === 100){
                    doneCount.push(rowNode.data)
                  }
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              case 'Task' :
              case 'task' :
                if (!params.node.data.hasProgress) {
                  return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                }
                return `<div class="progress--circle progress--${params.node.data.progress}">
                        <div class="progress__number">${params.node.data.progress}%</div>
                    </div>`
              case 'MasterTask' :
                // return `<div class="progress--circle progress--${params.node.data.progress}">
                //         <div class="progress__number">${params.node.data.progress}%</div>
                //     </div>`
                params.api.forEachNode(function(rowNode, index) {
                  let childTask = '';
                  let doneChildTask = '';
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress) {
                    childTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.progress === 100) {
                    doneChildTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if(childTask) childTasks.push(childTask);
                  if(doneChildTask) doneCount.push(doneChildTask)
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "progress",
          tooltipComponentParams: { fieldName: "Progress" },
          width: 12
        },
        // {
        //   headerName: '',
        //   field: "type",
        //   width: 12,
        //   cellRenderer: function(params) {
        //     if(params.node.data.type === 'Engagement'){
        //       return `<span class="typeNameRenderer">E</span>`
        //     }else if (params.node.data.type === 'MasterTask'){
        //       return `<span class="typeNameRenderer">MT</span>`
        //     }else {
        //       return `<span class="typeNameRenderer">${params.node.data.type}</span>`
        //     }
        //   },
        //   cellClassRules: {
        //     "hover-over": function(params) {
        //       return params.node === potentialParent;
        //     }
        //   }
        // },
        {
          headerName: "",
          field: "timerCount",
          width: 15,
          // tooltipField: 'allowSharing',
          // resizable: true,
          cellRenderer: function(params) {
            switch(params.node.data.type) {
              case 'Engagement':
                return `<img class="imageRender" src=${empty} />`
              case 'Task' :
              case 'task' :
                if(params.node.data.timerCount){
                  return `<div class="timerBlock">
                        <div class="el-badge item" id="badge">
                            <sup class="el-badge__content" >
                            ${params.node.data.timerCount}
                            </sup>
                        </div>
                        <img class="timerRender" src=${timer} />
                      </div>`
                }else {
                  return `<img class="imageRender" src=${empty} />`
                }
              case 'MasterTask' :
                return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          }
        }
      ];
      this.rowSelection = "multiple";
      this.defaultColDef = {
        tooltipComponent: "customTooltip",
        suppressMovable: true,
        suppressMenu: true,
        resizable: true,
        editable: function (node){
          if(node.data.access && node.colDef.cellClass === 'name-cell' && node.data.type !== 'Engagement'){
            return true
          }
        },
        onCellValueChanged : function (node){
          const that = this;
          if (!node.newValue) {
            node.api.setFocusedCell(node.data.myIndex, node.colDef, false);
            node.api.startEditingCell({
              rowIndex: node.node.rowIndex,
              colKey: node.colDef,
              charPress: node.oldValue
            });
            return;
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          let uri = window.location.search.substring(1);
          let params = new URLSearchParams(uri);
          const companyId = params.get("companyId");
          axios.get(`/api/v1/engagementTasks/updateName?companyId=${companyId}&engagementId=${node.data.engagementId}&engagementTaskId=${node.data.id}&newName=${node.newValue}`)
            .then(response => {
            }).catch(err => {
            console.log(err)
          })
        },
        // field: 'name'
      };
      this.components = { fileCellRenderer: getFileCellRenderer() };
      this.groupDefaultExpanded = -1;
      this.getDataPath = data => {
        return data.filePath;
      };
      this.getRowHeight = params => {
        return 40;
      };
      this.getRowNodeId = data => {
        return data.id;
      };
      this.autoGroupColumnDef = {
        rowDrag: function(params) {
          if(params.data.id === 0){
            return false
          }else if(!params.data.access){
            return false
          }else{
            return true
          }
        },
        headerName: this.$i18n.t('engagement_name'),
        field: 'name',
        cellClass: 'name-cell',
        filter: "agTextColumnFilter",
        width: 110,
        cellRendererParams: {
          suppressCount: true,
          innerRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.name}</span>`
          }
          // innerRenderer: "fileCellRenderer"
        },
        cellClassRules: {
          "hover-over": params => {
            return params.node === potentialParent;
          }
        }
      };
      this.frameworkComponents = {
        customTooltip: customTooltip
      };
      this.rowClassRules = {
        'no-access': '!data.access',
      };
    },
    mounted() {
      if(localStorage.getItem('isWorkDay')) {
          this.isWorkDay = true;
          this.getEngagements(this.$route.query.companyId).then(data =>{
            this.engagements = data
          });
          this.handleCommand('changeWorkDay');
          localStorage.removeItem('isWorkDay')
      }else if(this.$route.query.companyId) {
          this.loadCompanyData(this.$route.query.companyId)
      }
      this.gridApi = this.gridOptions.api;
      console.log("GRID API", this.gridApi);
      this.gridColumnApi = this.gridOptions.columnApi;
      this.gridApi.sizeColumnsToFit();
      this.gridColumnApi.moveColumn("myIndex", 0);
      setTimeout(() => {
        if(!this.companyLayout.permission.viewEngagements){
          this.$router.push('/login')
        }
      }, 1600);

      this.$options.sockets.companyInternalEvent = (data) => {
        if(!this.isWorkDay && this.valueEngagement === data.engagementId && this.companyLayout.companyUserId !== data.companyUserId){
          switch (data.action) {
            case 'updateNameEngagementTask'://+
              this.dynamicChangeRow(data.engagementTask, data.action);
              break;
            case 'createEngagementTaskTimer'://+
            case 'doneEngagementTask'://+
            case 'holdEngagementTask'://+
            case 'updateEngagementTask'://+
            case 'createEngagementTask'://+
            case 'startEngagementTask'://+
            case 'createParentEngagementTask'://+
            case 'insertEngagementTask': //+
            case 'createEngagementTaskProgress'://+
            case 'changeEngagementTaskParent'://+
            case 'restartEngagementTask'://+
            case 'deleteEngagementTaskProgress'://+
            case 'updateEngagementTaskList'://-
              new Promise (async (resolve, reject)=> {
                try {
                  const treeList = await this.getTreeList(this.$route.query.companyId, data.engagementId);

                  this.rowData = this.buildNewTree(treeList);

                  resolve('ok')
                } catch (err){
                  console.log(err)
                }
              }).then(resultOfUpdate => {
                this.dynamicChangeData(data.engagementTaskId, data.action);
              });
              break;
            case 'deleteEngegamentTask'://+
              this.dynamicDeleteFromData(data.engagementTaskId, data.action).then(async selectedRowId => {
                try {
                  const treeList = await this.getTreeList(this.$route.query.companyId, data.engagementId);
                  this.rowData = this.buildNewTree(treeList);
                    await setTimeout(()=>{
                      this.selectCreatedTask(selectedRowId)
                    }, 1000);
                }catch(err){
                  console.log(err)
                }
              });
              break;
            case 'updateEngegament'://+
              try {
                new Promise (async (resolve, reject) => {
                  const treeList = await this.getTreeList(this.$route.query.companyId, data.engagementId);
                  this.rowData = this.buildNewTree(treeList);
                  resolve('ok')
                }).then(data2 => {
                  this.onFlashRow(0).then(id => {
                    this.selectCreatedTask(id || this.rowData[0].id)
                  })
                });
              } catch (err) {
                console.log(err)
              }
              break;
            case 'deleteEngagement'://-
              this.rowData = [];
              this.valueEngagement = '';
              this.clientListId = '';
              this.selectedRow = {};
              localStorage.removeItem('selectedEngagementId');
              this.$router.push(`/engagements?companyId=${this.$route.query.companyId}`);
              this.getEngagements(this.$route.query.companyId);
              this.$alert('Engagement was deleted!', 'Warning', {
                confirmButtonText: 'OK',
                type: 'info'
              });
              break
          }
        }
      }
    },
    data() {
      return {
        // document
        dialogVisible: false,
        documentList: {
          companyId: null,
          projectId: null,
          projectTaskId: null,
          type: '',
          taskType: '',
          level: null
        },
        width: 0,
        height: 0,
        isWorkDay:false,
        sharedEngagementtaskNoteId:'',
        companyNameSelect: '',
        projectInfo: {
          description: null,
          progress: 0,
          engagementCompanyVendorList: [],
          engagementCompanyClientList: []
        },
        taskInfo: {
          name: null,
          priority: {
            name: null
          },
          progress: 0,
          status: 0,
          engagementTaskCompanyVendorList: [],
          engagementTaskCompanyClientPersonList: []
        },
        potentialParent: false,
        event: '',
        clientListId: '',
        clientList: [
          {name: 'All',
          id: 0}],
        valueEngagement: '',
        engagements: [],
        //engagements END
        activeInfoTab: 'first',
        activeInfoTaskTab: 'first',
        activeCRMTab: '',
        activeSCMTab: '',
        activeAccountTHINKTab: '',
        project: [],
        stages: [],
        region: [],
        valueProject: '',
        valueRegion: '',
        valueRegionId: '',
        activeEngagementId: '',
        engagementTaskId: '0',

        // Tree
        gridOptions: null,
        gridApi: null,
        columnApi: null,
        columnDefs: null,
        rowData: [],
        defaultColDef: null,
        components: null,
        groupDefaultExpanded: null,
        getDataPath: null,
        getRowNodeId: null,
        autoGroupColumnDef: null,
        getRowHeight: null,
        rowSelection: null,
        frameworkComponents: null,
        rowClassRules: null,

        // Tabs
        progressData: false,
        selectedEngagement: null,
        activeTab: 'first',
        isEngagement: true,
        newCreatedEngagementTask: null,

        //selectedRow
        disabledBtn : true,
        selectedRows:null,
        selectedRow: {},
        selectedEngagementForInfo:{},
        selectedTaskForInfo:{},
        bookmarkList:{},
        bookmarkListEngagement:{},

        //engagement permissions
        engagementPermission: {},
        expand: true,
    }
    },
    methods: {
      openScheduler() {
        this.$refs.schedulerModal.openModal({entityId: this.$route.query.engagementId, type: 'eng'})
      },
      logRequest(action){
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': action,
          'paramsLog': {
            buId: this.$route.query.engagementId,
            buTaskId: this.selectedRow.id
          }
        })
      },
      openPermissionsTab() {
        // TODO
        this.activeTab = 'first'
        this.activeInfoTab = 'permissions'
        this.$store.dispatch('getEngagementPermissionsList', this.$route.query.engagementId);
        this.$refs.infoTab.loadPermissionData();
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      underDevelopment() {
        this.$refs.underDevelopment.open()
      },
      async loadCompanyData(companyId){
          try {
              //Load Client List
              this.getClientsList();

              // Load Engagement List
              const engagementList = await this.getEngagements(companyId)

              //Check If Company Without Projects
              if(engagementList.length === 0){
                  this.valueEngagement = "";
                  this.engagements = [];
              }else {
                  this.engagements = engagementList
              }

              //Check If Project Selected in route
              if(this.$route.query.engagementId){
                  const rowData = await this.setEngagementRowData(Number(this.$route.query.engagementId))
                  this.activeInfoTab = 'first'

                  //Select Active Row
                  if(rowData.length > 0){
                      const selectedRow = await this.selectCreatedTask(Number(this.$route.query.taskId) || 0)
                  }

                  //Select Active Tab
                switch (this.$route.query.tabName) {
                  case 'engagementInfoTab':
                    this.activeTab = 'first';
                    this.activeInfoTab = 'first';
                    break;
                  case 'engagementTaskInfoTab':
                    this.activeTab = 'taskInfoTab';
                    this.activeInfoTaskTab = 'first';
                    break;
                  case 'setShared':
                    this.activeTab = 'taskInfoTab';
                    this.activeInfoTaskTab = 'progress';
                    break;
                  case 'createEngagementComment':
                    this.activeTab = 'engagementCommentTab';
                    break;
                  case 'createEngagementTaskComment':
                    this.activeTab = 'engagementTaskCommentTab';
                    break;
                  case 'createEngagementMessage':
                    this.activeTab = 'seven';
                    break;
                  case 'createEngagementTaskMessage':
                    this.activeTab = 'eight';
                    break;
                  case 'createEngagementFile':
                    this.activeTab = 'third';
                    break;
                  case 'createEngagementTaskFile':
                    this.activeTab = 'four';
                    break;
                  case 'createEngagementMeeting':
                    this.activeTab = 'nine';
                    break;
                  case 'createEngagementTaskMeeting':
                    this.activeTab = 'ten';
                    break;
                  case 'createEngagementHistory':
                    this.activeTab = 'eleven';
                    break;
                  case 'createEngagementTaskHistory':
                    this.activeTab = 'twelve';
                    break;
                  case 'reviewEngagementTaskDocument':
                    this.activeTab = 'taskInfoTab';
                    this.activeInfoTaskTab = 'documents';
                    break;
                  case 'createEngagementCrm':
                    this.activeTab = 'crm';
                    this.activeCRMTab = 'sellingProject';
                    break;
                  case 'createEngagementTaskCrm':
                    this.activeTab = 'crm';
                    this.activeCRMTab = 'sellingTask';
                    break;
                  case 'createEngagementScm':
                    this.isEngagement = true;
                    this.activeTab = 'scm';
                    this.activeSCMTab = 'purchaseProject';
                    break;
                  case 'createEngagementTaskScm':
                    this.isEngagement = false;
                    this.activeTab = 'scm';
                    this.activeSCMTab = 'purchaseTask';
                    break;
                  case 'createEngagementAccountTHINK':
                  case 'createEngagementTaskAccountTHINK':
                    this.activeTab = 'aTHINK';
                    this.activeAccountTHINKTab = 'budget';
                    break;
                }
              }

          }catch(err){
              console.log('loadData', err)
          }
      },
      // document
      handleClose(done) {
        this.dialogVisible = false
      },
      signDocument() {
        this.dialogVisible = false;

        switch (this.documentList.taskType){
          case 'PROJECT':
            this.$router.push(`/projects?companyId=${this.documentList.companyId}&projectId=${this.documentList.projectId}&taskId=${this.documentList.projectTaskId}&tabName=reviewProjectTaskDocument&activeDocumentTab=${this.documentList.type}`);
            break;
          case 'BUSINESSUNIT':
            this.$router.push(`/business-units/?companyId=${this.documentList.companyId}&businessUnitId=${this.documentList.projectId}&taskId=${this.documentList.projectTaskId}&tabName=reviewBusinessUnitTaskDocument&activeDocumentTab=${this.documentList.type}`);
            break;
          default:
            // console.log('documentList', this.documentList);
            // console.log('documentList', this.getStateId);
            // return
            if (this.$route.query.taskId.toString() === this.documentList.projectTaskId.toString()) {
              this.activeTab = 'taskInfoTab';
              this.activeInfoTaskTab = 'documents';
              // this.$refs['taskInfoTab'].$refs.docs.selectTab(this.documentList.type);
              this.$store.dispatch('getDocumentsE', this.documentList.projectTaskId).then(data => {
                if (this.getStateId && this.getStateId === 'sop' ||
                  this.getStateId && this.getStateId === 'policy' ||
                  this.getStateId && this.getStateId === 'healthsafety' ||
                  this.getStateId && this.getStateId === 'riskAssesment' ||
                  this.getStateId && this.getStateId === 'general' ||
                  this.getStateId && this.getStateId === 'commercial' ||
                  this.getStateId && this.getStateId === 'envirenmental') {
                  this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                  // this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              })
            } else {
              this.$router.push({query: {companyId: this.documentList.companyId, engagementId: this.documentList.projectId, taskId: this.documentList.projectTaskId, tabName: 'reviewEngagementTaskDocument', activeDocumentTab: this.documentList.type}}).then(data => {
                this.$emit('rerenderMainLayout')
              })
              // this.setShared2(this.documentList.projectId, 'ProjectTaskDocument', this.documentList.projectTaskId, this.documentList.companyId)
            }
        }
      },

      resize(newRect) {
        this.$refs.wrap__tree.classList.add("activeted")
        this.width = newRect.width;
        console.log(this.width)
        this.height = newRect.height;
      },
      changeWorkDay(val, event, activeTask){
          this.selectedRow = {};
        if(val){
          this.$store.dispatch('getCompanyLayout').then(response => {
          console.log('this.gridApi', this.autoGroupColumnDef);
          // this.gridApi.setSuppressRowDrag(true);
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/engagementTaskWorkDayItems/list?companyId=${this.$route.query.companyId}&companyUserId=${response.companyUserId}`)
            .then(async response => {
              this.gridApi.setRowData(response.data.list);
              if (response.data.list.length) {
                this.gridApi.forEachNode((node, index) =>  {
                  if (node.data.id === activeTask || node.data.id === response.data.list[0].id) {
                    this.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
                    node.setSelected(true);
                  }
                });
              }
              loader.hide()
            })
            .catch(error => {
              loader.hide()
              console.log('An error occurred:', error);
            });
          })
        }else{
          this.getClientsList();
          // animBlock.classList.remove("hide")
          // this.gridApi.setSuppressRowDrag(false);
          if(this.selectedEngagement){
            this.valueEngagement = this.selectedEngagement;
            this.setEngagementRowDataInput(this.selectedEngagement, 'first')
          }else{
            this.rowData = [];
            this.$router.push(`/engagements?companyId=${this.$route.query.companyId}`)
          }
        }
      },
      closeMyWorkDay(){
        this.isWorkDay = false;
        this.changeWorkDay(this.isWorkDay)
      },

      setMyWorkDay(){
        localStorage.setItem('isWorkDay', 'engagementWorkDayOpen')
      },

      engagementOpenModal(state){
        this.$refs.addEngagement.addEngagement(state)
      },

      handleCommand(command){
        switch (command) {
          case 'changeWorkDay':
            this.isWorkDay = true;
            this.changeWorkDay(this.isWorkDay);
            break;
          case 'addEngagement':
            this.engagementOpenModal('create');
            break;
          case 'editEngagement':
            this.engagementOpenModal('update');
            break;
          case 'addTask':
            this.getEngagementDir('add');
            break;
          case 'duplicateTask':
            this.duplicateTask('duplicate');
            break;
          case 'editTask':
            this.getEngagementDir('edit');
            break;
          case 'deleteTask':
            this.removeTask();
            break;
          case 'saveTaskTree':
            this.saveTaskTree();
            break;
          case 'addEngagementExpense':
            this.openEngagementExpense();
            break;
          case 'addTaskExpense':
            this.openEngagementExpense();
            break;
          case 'createCashAdvance':
            this.openEngagementCashAdvance();
            break;
          case 'inviteUser':
            this.inviteUser();
            break;
          case 'addTaskTimer':
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTaskTimers/create?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRow.id}`)
              .then(response => {
                console.log('---/engagementTaskTimers/create', response.data);
                this.$store.dispatch('getTimerListCas', {engagementId: this.$route.query.engagementId, engagementTaskId: this.selectedRow.id})
                this.setEngagementRowDataInput(Number(this.$route.query.engagementId), 0, Number(this.$route.query.taskId));
                this.notification("Success", "Task start time", "success");
                this.activeTab = 'first';
                this.activeInfoTaskTab = 'progress'
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
            break;
          case 'deleteEngagement':
            this.deleteEngagement();
            break;
          case 'removeBUEngagement' :
            this.removeBUFromEngagement()
            break;
          case 'toggleEngagementBookmark':
            this.changeBookMarkEngagement(this.$route.query.companyId, this.$route.query.engagementId)
            break;
          case 'toggleEngagementTaskBookmark':
            this.changeBookMarkTask(this.$route.query.companyId, this.$route.query.engagementId, this.selectedRow.id)
            break;
          default:
        }
      },
      openEngagementExpense(){
        this.$refs['engagementExpenseModal'].openModal('engagementTaskExpenses')
      },
      openEngagementCashAdvance(){
        this.$refs['engagementCashAdvanceModal'].openModal('engagementTasksCashAdvance')
      },
      getEngagementDir(state){
        if(this.selectedRow.type === 'Engagement'){
          this.$refs['addEngagementTask'].openModal(state)
        }else if (this.selectedRow.type !== 'businessUnit' && state !== 'edit'){
          gridMessageBox.confirm('', this.$i18n.t('general_action'), {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$i18n.t('general_addToParent'),
            cancelButtonText: this.$i18n.t('general_insertTask'),
            center: true
          })
            .then(() => {
              // check if user dont have permissions to create task
              if (!this.engagementPermission.createTask) {
                  this.notification("Notification", "User Dont have permission to create task", "info");
                  return
              }
              if(state === 'add' && this.selectedRow.type === "Task" && this.selectedRow.taskStatus !== 1){
                this.$refs.addParent.open();
              }else{
                this.$refs['addEngagementTask'].openModal(state)
              }
            })
            .catch(action => {
                // check if user dont have permissions to insert task

                if (!this.engagementPermission.createTask) {
                    this.notification("Notification", "User Dont have permission to create task", "info");
                    return
                }
              if (action === 'cancel'){
                this.$refs['addEngagementTask'].openModal('insert');
              }
            })
        }else{
          this.$refs['addEngagementTask'].openModal(state)
        }
      },
      removeBUFromEngagement(){
        this.$refs.removeBuFromEngagementModal.openModal(this.$route.query.companyId, this.$route.query.engagementId)
      },
      refreshTreeAfterDeleteTimer(engagementId){
        if(this.isWorkDay || this.valueEngagement === engagementId){
          this.setEngagementRowData(Number(this.$route.query.engagementId), 0, Number(this.$route.query.taskId));
        }
      },
      setActiveTabs(data){
        return new Promise( async (resolve, reject) => {
          try {
            switch (data.notificationType) {
              case 'engagementInfoTab':
                this.activeTab = 'first';
                this.activeInfoTab = 'first';
                resolve('success');
                break;
              case 'engagementTaskInfoTab':
                this.activeTab = 'taskInfoTab';
                this.activeInfoTaskTab = 'first';
                resolve('success');
                break;
              case "setShared":
                this.activeTab = 'taskInfoTab';
                this.activeInfoTaskTab = 'progress';
                this.$refs.taskInfoTab.handleClick({name: 'progress'});
                resolve('success');
                break;
              case "createEngagementComment":
                this.activeTab = 'engagementCommentTab';
                resolve('success');
                break;
              case "createEngagementTaskComment":
                this.activeTab = 'engagementTaskCommentTab';
                resolve('success');
                break;
              case "createEngagementMessage":
                this.activeTab = 'seven';
                resolve('success');
                break;
              case "createEngagementTaskMessage":
                this.activeTab = 'eight';
                resolve('success');
                break;
              case "createEngagementFile":
                this.activeTab = 'third';
                resolve('success');
                break;
              case "createEngagementTaskFile":
                this.activeTab = 'four';
                resolve('success');
                break;
              case "createEngagementMeeting":
                this.activeTab = 'nine';
                resolve('success');
                break;
              case "createEngagementTaskMeeting":
                this.activeTab = 'ten';
                resolve('success');
                break;
              case "createEngagementHistory":
                this.activeTab = 'eleven';
                resolve('success');
                break;
              case "createEngagementTaskHistory":
                this.activeTab = 'twelve';
                resolve('success');
                break;
              case "reviewEngagementTaskDocument":
                this.activeTab = 'taskInfoTab';
                this.activeInfoTaskTab = 'documents';
                this.$refs['taskInfoTab'].$refs.docs.selectTab(data.stateId);
                resolve('success');
                break;
              case 'createEngagementCrm':
                this.activeTab = 'crm';
                this.activeCRMTab = 'sellingProject';
                resolve('success');
                break;
              case 'createEngagementTaskCrm':
                this.activeTab = 'crm';
                this.activeCRMTab = 'sellingTask';
                resolve('success');
                break;
              case 'createEngagementScm':
                this.isEngagement = true;
                this.activeTab = 'scm';
                this.activeSCMTab = 'purchaseProject';
                resolve('success');
                break;
              case 'createEngagementTaskScm':
                this.isEngagement = false;
                this.activeTab = 'scm';
                this.activeSCMTab = 'purchaseTask';
                resolve('success');
                break;
              case 'createEngagementAccountTHINK':
              case 'createEngagementTaskAccountTHINK':
                this.activeTab = 'aTHINK';
                this.activeAccountTHINKTab = 'budget';
                resolve('success');
                break;
            }
          } catch (err) {
            console.log(err)
          }
        });

      },
      openAddTaskModal(){
        this.$refs.taskModal.addTask();
        this.$refs['taskModal'].open()
      },

      refreshBlock(){
        this.clientListId = '';
        this.valueEngagement = '';
        this.rowData = [];
        this.disabledBtn = true;
        this.activeInfoTab = "0";
        this.getClientsList();
        // this.getProjectStages();
        this.getEngagements(this.$route.query.companyId);
      },
      getClientsList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyClients/list?companyId=${this.$route.query.companyId} `)
          .then(response => {
            console.log('---', response.data);
            this.clientList = [{ name: 'All', id: 0 }].concat(response.data.list);
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      getContextMenuItems(params) {
        if (params.node.data.id !== this.selectedRow.id && this.selectedRows.length === 1) {
          this.gridOptions.api.deselectAll();
        }
        this.selectCreatedTaskByRightClick(params.node.data.id)
        var _this = this;
        var data = params.node.data;
        var contextMenuItemList = [];
        if ((data.type === 'Task') || (data.type === 'MasterTask')) {
          if (this.selectedRows.length === 1) {
            if (!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_addTask'),
                disabled: !this.engagementPermission.createTask,
                action: function () {
                  console.log("THIS", this)
                  _this.getEngagementDir('add')
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if (!this.isWorkDay && data.type === 'Task') {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_duplicateTask'),
                disabled: !this.engagementPermission.createTask,
                action: function () {
                  _this.duplicateTask('duplicate')
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if (!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_editTask'),
                disabled: !this.engagementPermission.updateTask,
                action: function () {
                  _this.getEngagementDir('edit')
                },
                icon: '<i class="el-icon-edit"></i>',
              });
            }
            if (!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_deleteTask'),
                disabled: !this.engagementPermission.deleteTask,
                action: function () {
                  _this.removeTask();
                },
                icon: '<i class="el-icon-delete"></i>',
              });
            }
            contextMenuItemList.push({
              name: this.$i18n.t('general_grid_contextMenu_inviteUser'),
              disabled: !this.companyLayout.permission.inviteUser,
              action: function () {
                _this.inviteUser();
              },
              icon: '<i class="el-icon-plus"></i>',
            });
            // }
            if (data.type === 'Task' && data.taskStatus === 2 || data.type === 'Task' && data.taskStatus === 5) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_addTaskTimer'),
                action: function () {
                  _this.handleCommand('addTaskTimer');
                },
                icon: '<i class="el-icon-time"></i>',
              });
            }
          }else{
            contextMenuItemList.push({
              name: this.$t('general_grid_contextMenu_EditTeam'),
              action: function () {
                _this.$refs.ReassignTasksModal.editTaskListOpen();
              },
              icon: '<i class="el-icon-edit"></i>',
            },
            {
              name: this.$i18n.t('general_grid_contextMenu_addUsersToTeam'),
              action: function () {
              _this.$refs.addNewUserToTasksModal.addNewUsersOpen();
              },
              icon: '<i class="el-icon-edit"></i>',
            });
          }
        }
        if (data.type === 'Engagement') {
          contextMenuItemList.push({
            name: this.$i18n.t('general_grid_contextMenu_addTask'),
            disabled: !this.engagementPermission.createTask,
            action: function () {
              _this.getEngagementDir('add')
            },
            icon: '<i class="el-icon-plus"></i>',
          });
          contextMenuItemList.push({
            name: this.$i18n.t('engagement_dropdown_action_remove_BU_engagement'),
            disabled: !this.companyLayout.permission.updateEngagements,
            action: function () {
              _this.removeBUFromEngagement()
            },
            icon: '<i class="el-icon-edit"></i>',
          });
        }
        return contextMenuItemList;
      },
      getEngagements(companyId){
          return new Promise ((resolve, reject) => {
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                  .post(`/api/v1/engagements/list?companyId=${companyId}`)
                  .then(response => {
                      resolve(response.data.list)
                      loader.hide()
                  })
                  .catch(error => {
                      reject(error)
                      console.log('An error occurred:', error)
                      loader.hide()
                  })
          })
      },
      async addEngagementToRowData(companyId, engagementId) {
          // Load Engagement List
          this.engagements = await this.getEngagements(companyId)
          this.valueEngagement = engagementId

          await this.setEngagementRowDataInput(engagementId)
      },
      putEngagementIntoTable(engagementId) {
        console.log('engagementId', engagementId)
        this.addEngagementToRowData(this.$route.query.companyId, engagementId)
      },
      loadList({ companyId, engagementId }){
        this.addEngagementToRowData(companyId, engagementId)
      },
      getRowData(){

      },
      openShareProjectTask() {
        this.$refs.shareProjectTaskModal.$refs.shareProjectTaskModal.open();
      },
      TEST() {
        this.$refs.modal.createProjectOpen();
        this.$refs['modal'].$refs['createProject'].open()
      },
      async setValueEngagements(id) {
        if(!id){
          this.engagements = await this.getEngagements(this.$route.query.companyId)
        }else{
          console.log('---', 'setValueEngagements');
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagements/list?companyId=${this.$route.query.companyId}&companyClientIdList=${id}`)
            .then(response => {
              this.checkEngagements(response.data.list);
              console.log('engagements', response.data);
              console.log('engagements LIST', response.data.list);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            })
        }
      },
      checkEngagements(response){
        this.engagements = response;
        if (this.engagements.length < 1){
          this.valueEngagement = "";
          this.rowData = [];
          this.selectedEngagementForInfo = false;
          this.selectedTaskForInfo = false;
          this.activeTab = 'first';
          return
        }
        let myValDep = this.valueEngagement;
        for (let i = 0; i < response.length; i++){
          this.valueEngagement = response[i].id;
          if(myValDep !== response[i].id){
            this.activeTab = 'first';
            this.valueEngagement = ''
          }else if(myValDep === response[i].id){
            this.valueEngagement = response[i].id;
            return
          }
        }
        if(this.valueEngagement === ''){
          this.rowData = [];
          this.selectedEngagementForInfo = false;
          this.selectedTaskForInfo = false
        }
      },
      async setEngagementRowDataInput(engagementId, state, newCreatedProjectTask, ifReocuring){
         const rowData = await this.setEngagementRowData(engagementId, state, newCreatedProjectTask, ifReocuring)
         const selectedRow = await this.selectCreatedTask(newCreatedProjectTask || 0)
      },
      // SET engagements INTO TABLE
      setEngagementRowData(id, state, newCreatedProjectTask, ifReocuring) {
          return new Promise ((resolve, reject) => {
              if(this.isWorkDay){
                this.isWorkDay = false;
                this.getClientsList();
                this.gridApi.setSuppressRowDrag(false);
                this.$message({
                  type: 'info',
                  message: this.$t('general_workdayClosed')
                });
                  // this.changeWorkDay(this.isWorkDay, false, newCreatedProjectTask)
                  // return
              }
              let loader = this.$loading.show();
              this.selectedEngagement = id;
              localStorage.setItem('selectedEngagementId', id);
              this.valueEngagement = id;
              if(state === "first") {
                  this.$router.push(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${id}&taskId=0`)
              }
              console.log('SET Engagement ROW DATA ID', id);
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                  .post(`/api/v1/engagementTasks/list?companyId=${this.$route.query.companyId}&engagementId=${id}`)
                  .then(response => {

                    this.rowData = this.buildNewTree(response.data.newList);
                    if(!response.data.newList[0].engagementClientList.length) {
                        this.clientListId = 0
                    }else if(this.clientListId !== 0){
                        this.clientListId = response.data.newList[0].engagementClientList[0]
                    }
                    resolve(this.rowData);
                    loader.hide()
                  })
                  .catch(error => {
                      console.log('An error occurred:', error);
                      loader.hide()
                  });
          })
      },
      selectCreatedTask(id) {
          return new Promise ((resolve, reject) => {
            let that = this
            let ifUserHaveAccesstoTask = false;
            this.gridApi.forEachNode(function(node) {
                  if (node.data.id === id && node.data.access) {
                      ifUserHaveAccesstoTask = true;
                      that.gridApi.ensureIndexVisible(node.rowIndex, 'middle')
                      node.setSelected(true);
                      resolve(node)
                  }
              });
            // CHECK IF USER SELECTED TASK WITH ACCESS IF NOT SELECT FIRST TASK WITH ACCESS
            if (!ifUserHaveAccesstoTask) {
              const accessedRows = that.rowData.filter(val => val.access);
              if(accessedRows.length) {
                this.selectCreatedTask(accessedRows[0].id)
              }
            }
          })
      },
      selectCreatedTaskNotification(id) {
        return new Promise ((resolve, reject) => {
          this.gridOptions.api.deselectAll();
          let that = this;
          let ifUserHaveAccesstoTask = false;
          this.gridApi.forEachNode(function (node, index) {
            // CHECK IF USER HAVE ACCESS TO TE ROW
            if (node.data.id === id && node.data.access) {
              // SET TO TRUE IF HAVE ACCESS
              ifUserHaveAccesstoTask = true;
              // MOVE TASK TO MIDDLE CENTER
              that.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
              node.setSelected(true);
              resolve(node)
            }
          });
          // CHECK IF USER SELECTED TASK WITH ACCESS IF NOT SELECT FIRST TASK WITH ACCESS
          if (!ifUserHaveAccesstoTask) {
            const accessedRows = that.rowData.filter(val => val.access);
            if(accessedRows.length) {
              this.selectCreatedTask(accessedRows[0].id)
            }
          }

        })
      },
      selectCreatedTaskByRightClick(id) {
          return new Promise ((resolve, reject) => {
              this.gridApi.forEachNode(function(node) {
                  if (node.data.id === id && node.data.access) {
                      node.setSelected(true);
                      resolve(node)
                  }
              });
          })
      },
      openInfo(active, id){
        this.activeInfoTab = active;
        this.getDepatmentInfo(id);
      },
      find(array, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i].id == value) return true;
        }
        return false
      },
      taskNotFoundOpenMadal(){
        this.$refs.taskNotFound.open();
        setTimeout(() => {
          this.activeTab = 'first';
          this.activeInfoTab= 'first';
          this.gridOptions.api.deselectAll();
          this.selectCreatedTask(0);
          this.$refs.taskNotFound.close()
        }, 2000)
      },
      onRowDragMove(event) {
        setPotentialParentForNode(event.api, event.overNode);
      },
      onRowDragLeave(event) {
        setPotentialParentForNode(event.api, null);
      },
      onRowDragEnd(event) {

        // CHECK IF DROP TASK TO ITSELF
        if (event.node.id === potentialParent.id) {
          setPotentialParentForNode(event.api, null);
          return
        }

        // CHECK IF USER HAVE ACCESS TO POTENTIAL PARENT
        if(!potentialParent.data.access) {
          setPotentialParentForNode(event.api, null);
          this.notification("Info", "No access", "info");
          return
        }

        this.potentialParent = potentialParent;
        this.event = event;

        switch(potentialParent.data.type) {
          case 'Engagement':
            this.notification("Info", "DnD Action not allowed for Engagement task", "info");
            setPotentialParentForNode(event.api, null);
            break;
          case 'MasterTask':
            // check if potential parent is parent of moved task
            if (potentialParent.id === event.node.parent.id) this.openActionModalForStartedTasks(event);

            else this.openActionModalForMasterTask(event);
            break;
          case 'Task':
            // IF TASK NOT STARTED
            if (potentialParent.data.taskStatus === 1) this.openActionModalForMasterTask(event);
            // IF TASK STARTED
            else this.openActionModalForStartedTasks(event)
        }

        // this.$refs.dragEnd.open();
      },
      openActionModalForMasterTask(event){
        gridMessageBox.confirm('', 'Action', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Add to parent',
          cancelButtonText: 'Move Task',
          center: true
        })
          .then(() => {
            // when select
            if(this.potentialParent.id !== 0){
              this.createParentTask('0')
            }
            // disable highlighted when click btn
            setPotentialParentForNode(event.api, null);
          })
          .catch(action => {
            // when select move task
            if (action === 'cancel'){
              this.createParentTask('1')
            }
            // disable highlighted when click btn
            setPotentialParentForNode(event.api, null);
          })
      },
      openActionModalForStartedTasks(event){
        gridMessageBox.alert('', 'Action', {
          confirmButtonText: 'Move Task',
          center: true
        })
          .then(() => {
            // when select
            this.createParentTask('1');
            // disable highlighted when click btn
            setPotentialParentForNode(event.api, null);
          })
          .catch(action => {
            // when select move task
            setPotentialParentForNode(event.api, null);
          })
      },
      createParentTask(state){
        const potentialParent = this.potentialParent
        const event = this.event
        if (!potentialParent) {
          return;
        }else if((potentialParent.data.type === "Task" && potentialParent.data.taskStatus === 2 && state === '0' ||
                  potentialParent.data.type === "Task" && potentialParent.data.taskStatus === 5 && state === '0')){
          // this.$refs.dragEnd.close()
          this.notification("Notification", "TASK ALREADY STARTED!!", "info")
          setPotentialParentForNode(event.api, null);
          return
        }else if(potentialParent.data.timerCount && state === '0'){
          // this.$refs.dragEnd.close()
          this.notification("Notification", "STOP TIMER", "info")
          setPotentialParentForNode(event.api, null);
          return
        }
        console.log(potentialParent, 'BOOOOOOM');
        let parentId = ''
        if (potentialParent.id === 0) {
          parentId = null
        } else {
          parentId = potentialParent.id
        }
        var movingData = event.node.data;
        var newParentPath = potentialParent.data ? potentialParent.data.filePath : [];
        var needToChangeParent = !arePathsEqual(newParentPath, movingData.filePath);
        var invalidMode = isSelectionParentOfTarget(event.node, potentialParent);
        if (invalidMode) {
          console.log("invalid move");
        }

        let isPutChild = true
        for (let i = 0; i < potentialParent.data.filePath.length; i++){
          if(movingData.id.toString() === potentialParent.data.filePath[i]){
            // this.$refs.dragEnd.close()
            this.notification("Notification", "YOU SHALL NOT PASS!!", "info")
            console.log(movingData, 'MOVING DATA');
            console.log(potentialParent, 'Potential PARENT');
            isPutChild = false
          }
        }

        console.log(isPutChild, 'IS PUT CHILD');
        if (needToChangeParent && !invalidMode && isPutChild) {
          var updatedRows = [];
          moveToPath(newParentPath, event.node, updatedRows);
          this.gridApi.updateRowData({update: updatedRows});
          this.gridApi.clearFocusedCell();
          console.log('potentialParent.data.orderIndex', state)
          this.dragTaskEnd(this.$route.query.companyId, this.$route.query.engagementId, movingData.id, parentId, state, potentialParent.data.orderIndex)
        }
        setPotentialParentForNode(event.api, null);
      },
      dragTaskEnd(companyId, engagementId, selectedRowId, parentId, state, orderIndex){
        // alert(engagementId)
        // this.$refs.dragEnd.close();
        if(state === '1'){
          const parentOfHoveredTask = this.rowData.filter(val => val.id === parentId)[0];
          parentId = parentOfHoveredTask.parentengagementTaskId;

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/engagementTasks/changeParent?companyId=${companyId}&engagementId=${engagementId}&engagementTaskId=${selectedRowId}&move=${state}&engagementTaskOrderIndex=${orderIndex}`, {
            newParentEngagementTaskId: parentId
          })
            .then(response => {
              if(response.data.success){
                this.notification("Success", "Moved Task", "success");
                loader.hide();
                // this.$refs.dragEnd.close();
                this.setEngagementRowDataInput(Number(engagementId), false, selectedRowId)
              }
              console.log('AFTER DRAG TASK');
            })
            .catch(error => {
              loader.hide()
              this.notification("Notification", error.response.data.message, "info");
              console.log('An error occurred:', error);
            })
        }else{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/engagementTasks/changeParent?companyId=${companyId}&engagementId=${engagementId}&engagementTaskId=${selectedRowId}&move=${state}&engagementTaskOrderIndex=${orderIndex}`, {
            newParentEngagementTaskId: parentId
          })
            .then(response => {
              if(response.data.success){
                loader.hide()
                this.notification("Success", "TASK ADDED TO PARENT", "success");
                // this.$refs.dragEnd.close();
                this.setEngagementRowDataInput(Number(engagementId), false, selectedRowId)
              }
              console.log('AFTER DRAG TASK');
            })
            .catch(error => {
              loader.hide()
              this.notification("Notification", error.response.data.message, "info");
              console.log('An error occurred:', error);
            })
        }
      },
      onGridReady(params) {},
      onSelectionChanged(api) {

        // check if really row selected or deselectAll()
        if (!this.gridApi.getSelectedRows().length) return;

        this.disabledBtn = false;
        this.selectedRows = this.gridApi.getSelectedRows();
        this.selectedRow = this.selectedRows[0];
        this.activeEngagementId = this.selectedRow.engagementId;
        console.log('SELECTED ROWS', this.selectedRows);
        console.log('SELECTED ROW', this.selectedRow);

        this.$router.replace(`/engagements?companyId=${this.$route.query.companyId}&engagementId=${this.activeEngagementId}&taskId=${this.selectedRow.id}`)

        if(this.selectedRow.type === 'Engagement'){
          //CLICK TABLE
          this.isEngagement = true;
          this.getEngagementLayout(this.$route.query.companyId, this.selectedRow.engagementId);
          if(this.activeTab === 'taskInfoTab'){
            this.activeTab = 'first'
          }
          if(this.activeTab === 'four'){
            this.activeTab = 'third'
          }
          if(this.activeTab === 'engagementTaskCommentTab'){
            this.activeTab = 'engagementCommentTab'
          }
          if(this.activeTab === 'second'){
            this.activeTab = 'first'
          }
          if(this.activeTab === 'eight'){
            this.activeTab = 'seven'
          }
          if(this.activeTab === 'ten'){
            this.activeTab = 'nine'
          }
          if(this.activeTab === 'twelve'){
            this.activeTab = 'eleven'
          }
          // Documents
          if(this.activeTab === 'fourteen'){
            this.activeTab = 'first'
          }

          switch (this.activeTab) {
            case 'first':
              this.getDepatmentInfo(this.selectedRow.id);
              console.log('ACTIVE Engagement INFO TAB');
              // history
              this.$store.dispatch('getEngagementHistory');
              break;
            case 'second':
              console.log("Engagement PROGRESS TAB SELECTED");
              break;
            case 'third':
              console.log("Engagement FILES TAB SELECTED");
              this.$store.dispatch('getEngagementFiles');
              break;
            case 'engagementCommentTab':
              this.$store.dispatch('getEngagementComments').then(list => {
                if (list.length && this.getStateId) {
                  const selectedComment = list.filter(val => val.id === this.getStateId);
                  if (selectedComment.length) this.$refs.engagementCommentTab.selectActiveCommentNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'seven':
              this.$store.dispatch('getMessagesDirectories', {'type': 'engagement', 'engagementId': this.activeEngagementId});
              this.$store.dispatch('getMessagesList', {'type': 'engagement', 'engagementId': this.activeEngagementId, 'projectMessageType': '1'});
              break;
            case 'nine':
              // this.$store.dispatch('getEngagementMeetings');
              this.getDepatmentInfo()
              console.log("ENGAGEMENT MEETINGS TAB SELECTED")
              this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.$route.query.engagementId, typeId: 3, taskId: null, page: 1}).then(list => {
                if (list.length && this.getStateId) {
                  const selectedMeeting = list.filter(val => val.id === this.getStateId);
                  if (selectedMeeting.length) this.$refs.engagementMeetingTab.selectActiveMeetingNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'eleven':
              console.log("Engagement HISTORY TAB SELECTED");
              this.$store.dispatch('getEngagementHistory');
              break;
            case 'permissions':
              this.$store.dispatch('getEngagementPermissionsList', this.$route.query.engagementId);
              this.$refs.infoTab.loadPermissionData();
              break;
            case 'about':
              this.$store.dispatch('about', 'engagement')
              break;
          }
          // this.activeInfoTab = 'first';
        }else if(this.selectedRow.type === 'MasterTask' || this.selectedRow.type === 'Task'){
          this.isEngagement = false;
          this.getTaskLayout(this.$route.query.companyId, this.selectedRow.engagementId, this.selectedRow.id)
          if(this.activeTab === 'first'){
            this.activeTab = 'taskInfoTab'
          }
          if(this.activeTab === 'third'){
            this.activeTab = 'four'
          }
          if(this.activeTab === 'engagementCommentTab'){
            this.activeTab = 'engagementTaskCommentTab'
          }
          if(this.selectedRow.type === 'MasterTask'&& this.activeTab === 'second'){
            this.activeTab = 'taskInfoTab'
          }
          if(this.activeTab === 'seven'){
            this.activeTab = 'eight'
          }
          if(this.activeTab === 'nine'){
            this.activeTab = 'ten'
          }
          if(this.activeTab === 'eleven'){
            this.activeTab = 'twelve'
          }

          switch (this.activeTab) {
            case 'taskInfoTab':
              this.getEngagementTaskInfo()
              switch (this.activeInfoTaskTab) {
                case 'five':
                  this.$store.dispatch('getEngagementTaskHistory');
                  break;
                case 'progress':
                  if (this.selectedRow.type === 'MasterTask' || !this.selectedRow.hasProgress) {
                    this.activeInfoTaskTab = 'first';
                    this.getEngagementTaskInfo()
                  } else {
                    this.getEngagementProgressList(this.selectedRow.id);
                    this.$store.dispatch('getTimerListCas', {engagementId: this.activeEngagementId, engagementTaskId: this.selectedRow.id})
                  }
                  break;
                case 'documents':
                  this.$store.dispatch('getDocumentsE', this.selectedRow.id).then(data => {
                    if (this.getStateId && this.getStateId === 'sop' ||
                      this.getStateId && this.getStateId === 'policy' ||
                      this.getStateId && this.getStateId === 'healthsafety' ||
                      this.getStateId && this.getStateId === 'riskAssesment' ||
                      this.getStateId && this.getStateId === 'general' ||
                      this.getStateId && this.getStateId === 'commercial' ||
                      this.getStateId && this.getStateId === 'envirenmental') {
                        this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                      this.$store.dispatch('setStateId', null)
                    } else {
                      this.$store.dispatch('setStateId', null)
                    }
                  });
                  break;
                case 'toDo':
                  this.$store.dispatch('toDo', 'engagement')
                  break;
                case 'about':
                  this.$store.dispatch('about', 'engagementTask')
                  break;
              }
              break;
            case 'second':
              console.log("Engagement TASK PROGRESS TAB SELECTED")
              this.getEngagementProgressList(this.selectedRow.id);
              this.$store.dispatch('getTimerListCas', {engagementId: this.activeEngagementId, engagementTaskId: this.selectedRow.id})
              break;
            case 'four':
              console.log("Engagement TASK FILES TAB SELECTED")
              this.$store.dispatch('getCasTaskFiles', this.selectedRow.id )
              break;
            case 'engagementTaskCommentTab':
              this.$store.dispatch('getEngagementTaskComments', this.selectedRow.id).then(list => {
                if (list.length && this.getStateId) {
                  const selectedComment = list.filter(val => val.id === this.getStateId);
                  if (selectedComment.length) this.$refs.engagementTaskCommentTab.selectActiveCommentNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              })
              break;
            case 'eight':
              this.$store.dispatch('getMessagesDirectories', {'type': 'taskEngagement', 'engagementId': this.activeEngagementId, 'engagementTaskId': this.selectedRow.id})
              this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeEngagementId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
              if(this.$refs.MessagesTask){
                this.$refs.MessagesTask.currentTabComponent = 'MessagesReceived'
              }
              break;
            case 'ten':
              this.getEngagementTaskInfo()
              // this.$store.dispatch('getEngagementTaskMeetings', {engagementId: this.activeEngagementId, taskId:this.selectedRow.id});
              this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.activeEngagementId, typeId: 6, taskId: this.selectedRow.id, page: 1}).then(list => {
                if (list.length && this.getStateId) {
                  const selectedMeeting = list.filter(val => val.id === this.getStateId);
                  if (selectedMeeting.length) this.$refs.engagementTaskMeetingTab.selectActiveMeetingNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'twelve':
              this.$store.dispatch('getEngagementTaskHistory', this.selectedRow.id)
              break;
            // case 'fourteen':
            //   this.$store.dispatch('getDocumentsE', this.selectedRow.id)
            //   break;
          }
        }
      },
      getEngagementLayout(companyId, engagementId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagementLayout/getData?companyId=${companyId}&engagementId=${engagementId}`)
            .then(response => {
              this.bookmarkListEngagement = response.data.bookmarks;
              this.engagementPermission = response.data.permission;

              this.gridApi.setSuppressRowDrag(!this.engagementPermission.moveTask);

              if (response.data.document) {
                // check if document set later
                if (response.data.document.date) {
                  this.openLaterConfirmDocumentModal(response.data.document);
                  loader.hide();
                  return;
                }
                this.documentList.companyId = response.data.document.companyId;
                this.documentList.projectId = response.data.document.engagementId;
                this.documentList.projectTaskId = response.data.document.engagementTaskId;
                this.documentList.taskType = response.data.document.taskType;
                if (response.data.document.type === 'riskassesment') {
                  this.documentList.type = 'commercial'
                } else if (response.data.document.type === 'envirenmental') {
                  this.documentList.type = 'general'
                } else {
                  this.documentList.type = response.data.document.type
                }
                // this.documentList.type = response.data.document.type
                this.signInDocumentOpenModal(response.data.document.id);
              } else {
                if (this.$session.has('documentId')) this.$session.remove('documentId');
              }
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        })
      },
      duplicateTask(state){
        this.$confirm(this.$i18n.t('general_doYouWantToDuplicateThisTask'), '', {
          confirmButtonText: this.$i18n.t('general_yes'),
          cancelButtonText: this.$i18n.t('general_cancel'),
          type: 'info'
        }).then(() => {
          try {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.get(`/api/v1/engagementTasks/duplicate?companyId=${this.$route.query.companyId}&engagementId=${this.selectedRow.engagementId}&engagementTaskId=${this.selectedRow.id}`)
              .then(response => {
                loader.hide();
                this.$message({
                  type: 'success',
                  message: 'Duplication completed'
                });
                this.setEngagementRowDataInput(this.selectedRow.engagementId, false, response.data.engagementTaskId)
              }).catch(err => {
              loader.hide();
              console.log(err)
            });
          }catch(err){
            console.log(err)
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Duplication canceled'
          });
        });
      },
      getTaskLayout(companyId, businessUnitId, taskId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagementTaskLayout/getData?companyId=${companyId}&engagementId=${businessUnitId}&engagementTaskId=${taskId}`)
            .then(response => {
              this.bookmarkList = response.data.data.bookmarks;
              this.engagementPermission = response.data.permission;

              //check drag and drop from permissions
              if (this.isWorkDay) this.gridApi.setSuppressRowDrag(true);
              else this.gridApi.setSuppressRowDrag(!this.engagementPermission.moveTask);

                if (response.data.document) {
                  // check if document set later
                  if (response.data.document.date) {
                    this.openLaterConfirmDocumentModal(response.data.document);
                    loader.hide();
                    return
                  }
                this.documentList.companyId = response.data.document.companyId;
                this.documentList.projectId = response.data.document.engagementId;
                this.documentList.projectTaskId = response.data.document.engagementTaskId;
                this.documentList.taskType = response.data.document.taskType;

                  if (response.data.document.type === 'riskassesment') {
                  this.documentList.type = 'commercial'
                } else if (response.data.document.type === 'envirenmental') {
                  this.documentList.type = 'general'
                } else {
                  this.documentList.type = response.data.document.type
                }
                // this.documentList.type = response.data.document.type
                  if (!this.$session.has('documentId')) {

                    this.signInDocumentOpenModal(response.data.document.id);

                  } else {
                    const documentId = this.$session.get('documentId');
                    const documentIdFromRequest = response.data.document.id;

                    if (documentId !== documentIdFromRequest) {
                      this.signInDocumentOpenModal(response.data.document.id);
                    } else {
                      this.$session.remove('documentId')
                    }
                  }
                }else {
                  if (this.$session.has('documentId')) this.$session.remove('documentId');
                }
                loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        })
      },
      signInDocumentOpenModal(documentId){
        this.$alert(this.$t('modal_documents_youHaveDocumentsThatRequireAction'), this.capitalizeFirstLetter(this.documentList.type), {
          confirmButtonText: this.$t('general_ok'),
          showClose: false,
          callback: action => {
            switch (action){
              case 'confirm':
                this.$session.set('documentId', documentId);
                this.$store.dispatch('setStateId', this.documentList.type);
                this.signDocument();
                break;
              case 'cancel':
                this.$session.remove('documentId');
                break
            }
          }
        });
      },
      openLaterConfirmDocumentModal(document) {
        this.$refs.laterDocumentModal.openModal(document)
      },
      getDepatmentInfo(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagements/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}`)
          .then(response => {
            console.log('---/engagements/extendedInfo', response.data.extendedInfo);
            response.data.extendedInfo.engagementCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.engagementCompanyClientList.sort(function (a, b) {
              if (a.companyClient.name.toLowerCase() > b.companyClient.name.toLowerCase()) {
                return 1;
              }
              if (a.companyClient.name.toLowerCase() < b.companyClient.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.engagementCompanyVendorList.sort(function (a, b) {
              if (a.companyVendor.name.toLowerCase() > b.companyVendor.name.toLowerCase()) {
                return 1;
              }
              if (a.companyVendor.name.toLowerCase() < b.companyVendor.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            // let start = null
            // if (response.data.extendedInfo.dateData.plannedStartDate) {
            //   start = response.data.extendedInfo.dateData.plannedStartDate.toString();
            //   if (start.length < 8) {
            //     start = '0' + start
            //   }
            // }

            // let review = null
            // if (response.data.extendedInfo.dateData.reviewDate) {
            //   review = response.data.extendedInfo.dateData.reviewDate.toString();
            //   if (review.length < 8) {
            //     review = '0' + review
            //   }
            // }

            // response.data.extendedInfo.dateData.plannedStartDate = start
            // response.data.extendedInfo.dateData.reviewDate = review

            this.projectInfo = response.data.extendedInfo
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getEngagementTaskInfo(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTasks/extendedInfo?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRow.id}`)
          .then(response => {
            console.log('---/engagementTasks/extendedInfo', response.data.extendedInfo);
            response.data.extendedInfo.engagementCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.engagementTaskCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.engagementTaskCompanyClientList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.engagementTaskCompanyVendorList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            this.taskInfo = response.data.extendedInfo;
            this.isEngagement = false
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getEngagementProgressList(id){
        this.$store.dispatch('getEngagementProgressesList', id).then(list => {
          if (list.length && this.getStateId) {
            const progressItem = list.filter(val => val.id === this.getStateId);
            if (progressItem) {
              this.$refs.taskInfoTab.$refs.engProgressTab.selectActiveProgressNode(this.getStateId);
            } else {
              this.$store.dispatch('setStateId', null)
            }
          }
        })
      },
      addTask() {
      },
      closeAddNewTask(){

      },
      editTask() {
        console.log('---', 'edit');
        this.$refs.editTask.open();
      },
      shareTask() {

        console.log('---', 'share');
      },
      async removeTask() {
        try {
          if (this.selectedRow.type === 'MasterTask') return this.notification(this.$t('general_warning'), this.$t('modal_notification_cantDeleteMasterTask'), "info");

          // check if current task has documents
          const documents = await this.$store.dispatch('getDocumentsE', this.selectedRow.id);
          let ifDocumentsAttached = false;
          if (documents.envirenmental || documents.healthsafety || documents.policy || documents.riskAssesment || documents.sop) ifDocumentsAttached = true;

          this.$confirm(ifDocumentsAttached ? this.$t('modal_engagement_afterDeletingEngagementTaskAttachedDocumentsWillBeDeletedTooContinue') : this.$t('modal_engagement_thisWillPermanentlyDeleteTheEngagementTaskContinue'), this.$t('general_warning'), {
            confirmButtonText: this.$t('general_ok'),
            cancelButtonText: this.$t('general_cancel'),
            type: 'info'
          }).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('general_deleteCompleted')
            });

            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/engagementTasks/delete?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRow.id}`)
              .then(response => {
                console.log('deleted task', response.data);
                let id = this.activeEngagementId;
                if (response.data.success) {
                  console.log("success");
                  this.setEngagementRowDataInput(id);
                }
                loader.hide()
              })
              .catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('general_deleteCanceled')
            });
          });
        } catch (err) {
          console.log(err)
        }
      },
      saveTaskTree() {
        this.$refs['modal777'].$refs['saveTaskTreeProject'].open()
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      handleClick(tab, event){
        console.log("THIS ACTIVE TAB", tab);
        console.log(tab.name, event);
        if(tab.name === 'first'){
          this.getDepatmentInfo(this.$route.query.engagementId);
          this.logRequest('log_e_info')
        }else if (tab.name === 'taskInfoTab') {
          this.getEngagementTaskInfo()
          this.logRequest('log_e_task_info')
        }else if(tab.name === 'second'){
          this.getEngagementProgressList(this.selectedRow.id);
          this.$store.dispatch('getTimerListCas', {engagementId: this.activeEngagementId, engagementTaskId: this.selectedRow.id})
          this.logRequest('log_e_task_progress')
        }else if(tab.name === 'third'){
          this.$store.dispatch('getEngagementFiles')
          this.logRequest('log_e_files')
        }else if(tab.name === 'four'){
          this.$store.dispatch('getCasTaskFiles', this.selectedRow.id)
          this.logRequest('log_e_task_files')
        }else if(tab.name === 'engagementCommentTab'){
          this.$store.dispatch('getEngagementComments', this.selectedRow.id)
          this.logRequest('log_e_comments')
        }else if(tab.name === 'engagementTaskCommentTab'){
          this.$store.dispatch('getEngagementTaskComments', this.selectedRow.id)
          this.logRequest('log_e_task_comments')
        }else if(tab.name === 'seven'){
          this.$store.dispatch('getMessagesDirectories', {'type': 'engagement', 'engagementId': this.activeEngagementId})
          this.$store.dispatch('getMessagesList', {'type': 'engagement', 'engagementId': this.activeEngagementId, 'projectMessageType': '1'})
          this.logRequest('log_e_messages')
        }else if(tab.name === 'eight'){
          this.$store.dispatch('getMessagesDirectories', {'type': 'taskEngagement', 'engagementId': this.activeEngagementId, 'engagementTaskId': this.selectedRow.id})
          this.$store.dispatch('getMessagesList', {'type': 'taskEngagement', 'engagementId': this.activeEngagementId, 'engagementTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          this.logRequest('log_e_task_messages')
        }else if(tab.name === 'nine') {
          this.$store.dispatch('getMeetings', {typeId: 3, companyId: this.$route.query.companyId, taskId: null, parentId: this.activeEngagementId, page: 1});
          // this.$store.dispatch('getEngagementMeetings')
          this.logRequest('log_e_meetings')
        }else if(tab.name === 'ten'){
          this.$store.dispatch('getMeetings', {typeId: 6, companyId: this.$route.query.companyId, taskId: this.selectedRow.id, parentId: this.activeEngagementId, page: 1});
          // this.$store.dispatch('getEngagementTaskMeetings', {engagementId: this.activeEngagementId, taskId:this.selectedRow.id})
          this.logRequest('log_e_task_meetings')
        }else if(tab.name === 'eleven') {
          this.$store.dispatch('getEngagementHistory')
          this.logRequest('log_e_history')
        }else if(tab.name === 'twelve') {
          this.$store.dispatch('getEngagementTaskHistory', this.selectedRow.id)
          this.logRequest('log_e_task_history')
        }
        // else if(tab.name === 'fourteen'){
        //   this.$store.dispatch('getDocumentsE', this.selectedRow.id)
        // }
      },
      getProgressesList(id) {
        this.$store.dispatch('getEngagementProgressesList', id).then(list => {
          if (list.length && this.getStateId) {
            const progressItem = list.filter(val => val.id === this.getStateId);
            if (progressItem) {
              this.$refs.taskInfoTab.$refs.engProgressTab.selectActiveProgressNode(this.getStateId);
            } else {
              this.$store.dispatch('setStateId', null)
            }
          }
        })
      },
      inviteUser() {
        this.$refs.inviteUserModal.openModalFromBasic('getEngagementList', this.$route.query.engagementId, this.selectedRow.id);
      },

      dynamicChangeRow(changedRow, action){
        console.log('ROOOOOOOOOOOOOW', changedRow)
        var itemsToUpdate = [];
        var newItem = changedRow;
        let indexItem = 0;
        this.gridApi.forEachNodeAfterFilterAndSort(function(rowNode, index) {
          if (rowNode.data.id === changedRow.id ) {
            indexItem = index
            var data = rowNode.data;
            data.name = changedRow.name;
            data.taskStatus = changedRow.status;
            data.taskTeamList = changedRow.taskTeamList;
            data.hasProgress = changedRow.hasProgress;
            data.progress = changedRow.progress;
            data.timerCount = changedRow.timerCount;
            if (changedRow.leader) {
              data.leader = changedRow.leader === null ? null : changedRow.leader.user
            }
            itemsToUpdate.push(data);
          }
        });
        // TODO COMMIT 28/02/2020
        this.gridApi.updateRowData({ update: itemsToUpdate });
        this.onFlashRow(indexItem).then(id => this.selectCreatedTask(id ||this.rowData[0].id))
      },

      getTreeList(companyId, engagementId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        return axios.post(`/api/v1/engagementTasks/list?companyId=${companyId}&engagementId=${engagementId}`)
          .then(response => {
            return response.data.newList;
          }).catch(err => {
            console.log(err)
          })
      },
      async getTreeScreen(){
        try {
          let loader = this.$loading.show();
          var eGridDiv = await document.querySelector('#myGrid');
          eGridDiv.style.height = '';
          await this.gridApi.setDomLayout('print');
          const canvas = await html2canvas(document.querySelector("#myGrid"));
          const fileUrl = await new Promise((resolve) => {
          const that = this;
          canvas.toBlob(function(blob) {
          try {
            const formData = new FormData();
            formData.append('file', blob, 'filename.png');
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/files/create?companyId=${that.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
              .then(response => {
                resolve(response.data.fileUrl);
              }).catch(error => {
                loader.hide();
                console.log('An error occurred:', error);
              });
            } catch (err){
              loader.hide();
              console.log(err)
            }
          });
        });
        eGridDiv.style.height = '100%';
        eGridDiv.style.width = '100%';
        await this.gridApi.setDomLayout(null);
        loader.hide();
        await this.$refs['modal777'].submitFormFileUrl(fileUrl)
        }catch (err){
          console.log(err)
        }
      },
      async dynamicChangeData(engagementTaskId, action){
        try {
          const taskIndex = await this.buildNewRowData2(engagementTaskId);
          console.log('!!!!taskIndex', taskIndex);

          const taskId = await this.onFlashRow(taskIndex);
          console.log('!!!!taskId', taskId);

          const selectedNode = await this.selectCreatedTask(taskId ||this.rowData[0].id);
          console.log('!!!!selectedNode', selectedNode);
        } catch (err){
          console.log(err)
        }
      },
      buildNewRowData2(engagementTaskId) {
        return new Promise((resolve, reject) => {
          this.gridApi.forEachNode(function(node, index) {
            if(engagementTaskId === node.data.id){
              resolve(index)
            }
          })
        })
      },
      onFlashRow(index) {
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode]
          });
          resolve(this.selectedRow.id)
        })
      },
      dynamicDeleteFromData(engagementTaskId, action){
        return new Promise ((resolve, reject) =>{
          this.buildNewRowData2(engagementTaskId).then(index => this.onFlashRowDelete(index)).then(id => {
            const myId = id === this.selectedRow.id ? 0 : this.selectedRow.id
              resolve(myId);
            // setTimeout(()=>{
            //   let selectedId = id;
            //   if(this.selectedRow.id === selectedId){
            //     this.selectCreatedTask(this.rowData[0].id)
            //   }else{
            //     this.selectCreatedTask(this.selectedRow.id)
            //   }
            // }, 1000)
          })
        })
      },
      onFlashRowDelete(index) {
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode]
          });
          resolve(rowNode.id)
        })
      },
      setNewPermissions(permissions){
       this.engagementPermission = permissions
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      deleteEngagement(){
        this.$confirm(this.$t('settings_engagements_ThisWillPermanentlyDeleteTheEngagementsContinue'), this.$t('settings_engagements_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('general_deleteCompleted')
          });
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/engagements/delete?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}`)
            .then(response => {
              // this.$refs.confirmation.close();
              localStorage.removeItem('selectedEngagementId');
              localStorage.removeItem('selectedEngagementTaskId');
              this.$router.push(`/engagements?companyId=${this.$route.query.companyId}`);
              this.refreshBlock();
              this.$store.dispatch('getMenuStatistics');
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      expandAll(){
        this.expand = !this.expand;
        if(this.expand){
          this.gridApi.forEachNode((node) => {
            node.setExpanded(true);
          })
        }else {
          this.gridApi.forEachNode((node) => {
            if(node.data.filePath.length === 2) {
              node.setExpanded(false);
            }
          })
        }
      },
      changeBookMarkEngagement(companyId, engagementId) {
        this.$confirm(this.bookmarkListEngagement.info ? this.$t('engagement_removeBookmark') : this.$t('engagemnt_addBookmark'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let data = this.bookmarkListEngagement
          data.info = !this.bookmarkListEngagement.info
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bookmarks/setEngagement?companyId=${companyId}&engagementId=${engagementId}`, data)
              .then(response => {
                if (this.bookmarkListEngagement.info) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
              });
        }).catch(err => {
          console.log('err', err)
        })
      },
      changeBookMarkTask(companyid, engagementId, taskId) {
        this.$confirm(this.bookmarkList.info ? this.$t('engagemnt_removeBookmark') : this.$t('engagemnt_addBookmark'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let data = this.bookmarkList;
          data.info = !this.bookmarkList.info;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bookmarks/setEngagementTask?companyId=${companyid}&engagementId=${engagementId}&engagementTaskId=${taskId}`, data)
              .then(response => {
                if (this.bookmarkList.info) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
              });
        }).catch(err => {
          console.log('err', err)
        })
      },
      buildNewTree(list) {
        console.log('LIST 1', list);
        // CHECK IF USER COMPANY OWNER
        const companyLeader = this.companyLayout.isLeader
        // DECLARE MANAGER (LEADER) OF PROJECT
        let ifUserManager = false;
        // CHECK USER ACCESS TO PROJECT START
        const companyUserId = this.companyLayout.companyUserId.toString();
        const even = (element) => element === companyUserId;
        ifUserManager = list[0].userList.some(even);
        // CHECK IF USER LEADER OF PROJECT NOT JUST MANAGER
        for (let i = 0; i < list.length; i++) {
          if (ifUserManager || companyLeader) {
            list[i].access = true
          }else if (!ifUserManager && i === 0) {
            list[i].access = false
          }else if (!ifUserManager && i > 0){
            // check if user creator of task bu not in team
            if (this.user.user.id === list[i].creatorId){
              list[i].access = true
            }else {
              const ifUserInTaskTeam = list[i].taskTeamList.some(even);
              list[i].access = ifUserInTaskTeam
            }
          }
        }
        console.log('LIST 2', list);

        return list;
      },
    },
    watch:{
      rowData(val){
        if(val.length === 0){
          this.disabledBtn = true
        }else{
          this.disabledBtn = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    .sweet-modal-overlay{
        z-index:1000;
    }

    .engagements {
        background: #DfE8F0;
        z-index: 0;
        height: 100vh;
    }

    .content {
        display: flex;
        height: 100vh;
        padding-top: 50px;
    }
    .el-tabs{
        height:calc(100% - 73px);
    }
    // [ Wrapper ] start
    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 0 10px 10px 10px;
    }
    .wrap {
        display: flex;
        width: 100%;
        height: 100%;
        &__tree {
            width:100%;
            height:100%;
            // max-width: 634px;
            // min-width:634px;
            max-width: 700px;
            min-width:700px;
            min-height:100%;
            padding: 0 10px 10px 0;
            &.activeted{
                width:auto;
                height:100%;
                min-width:auto;
            }
        }
        &__info {
            max-width:100%;
            width: 100%;
            min-width:50%;
            padding: 0 0 10px 10px;
            .nav-project{
                height:73px;
            }
        }
    }
    // [ Wrapper ] end

    // [ Nav tree ] start
    .nav-project {
        max-height:73px;
        display:flex;
        justify-content:space-between;
        width:100%;
        padding: 20px 0px 20px 0;
        overflow:hidden;
        &__item {
            margin: 0 0 5px 0;
        }
        &_first-row{
            display:flex;
            justify-content: flex-start;
        }
        .el-select {
            margin-right: 10px;
        }
    }
    .nav-tree {
        &__item {
            margin: 0 0 5px 0;
        }
        .el-button {
            margin-right: 10px;
        }
    }
    #fade-in {
        /*transition: all .50s ease;*/
        width: 100%;
        /*height:32px;*/
        /*opacity: 1;*/
        overflow:hidden;
        .inputs{
            /deep/.el-input__inner{
                width:180px;
            }
        }
    }
    /*#fade-in.hide {*/
        /*overflow:hidden;*/
        /*opacity: 0;*/
        /*transition: all .50s ease;*/
        /*width: 1px;*/
        /*height:32px;*/
    /*}*/
    .work-day-block{
        z-index:1;
        width:100%;
        .close-work-day-btn{
            margin-right:10px;
        }
    }
    .vuedrag{
        /*width:100%;*/
        height:100% !important;
        position:relative;
    }
    .vdr.active:before{
        outline:none;
    }
    /deep/.vdr-stick-mr{
        /*background-color:transparent;*/
        /*border:none;*/
        /*box-shadow:none;*/
        /*&:before{*/
        /*font-family: "Font Awesome 5 Free";*/
        /*content: '\F337';*/
        /*position: absolute;*/
        /*font-weight: 900;*/
        /*right: -9px;*/
        /*font-size: 25px;*/
        /*top: -10px;*/
        /*}*/
    }
    // [ Nav tree ] end
    /*.input-recuring-counter{*/
        /*!*margin-left:10px;*!*/
        /*width:50px;*/
    /*}*/
    .engagement-info-menu {
      max-width: 400px;
    }
</style>

<style lang="less" scoped>
    /*.btn-wrap{*/
        /*position:relative;*/
        /*.star{*/
            /*color:#F56C6C;*/
            /*position:absolute;*/
            /*left: -20px;*/
            /*font-size:19px !important;*/
            /*font-weight:inherit;*/
        /*}*/
    /*}*/
    /*.repeat{*/
        /*width:100px;*/
    /*}*/
    /*.datepicker{*/
        /*width:100px;*/
    /*}*/
    /*.demo-ruleForm{*/
        /*text-align:left;*/
    /*}*/
    .flex-center{
        display: flex;
        justify-content: center;
    }
    .flex{
        display: flex;
        justify-content:space-between;
    }
    .two-columns > div{
        max-width:45%;
        width:100%;
    }
    .el-form-item{
        .el-select{
            width:100%;
        }
    }
    .draggble{
        display:flex;
        flex-direction:column;
        text-align:center;
        align-items:center;
        justify-content: center;
        .btn{
            width:120px;
            margin:5px 0;
        }
    }
    /*.flex-end{*/
        /*display:flex;*/
        /*justify-content: flex-end;*/
    /*}*/
    .task-not-found-block{
        text-align:center;
    }
    // GRID START
    /deep/.timerBlock{
        width: 28px;
        height: 28px;
        position:relative;
        margin-top: calc(50% - 17px);
        & #badge{
            z-index:1;
            position:absolute;
            top: -5px;
            right: -4px;
            & .el-badge__content{
                font-size:10px;
                height: 17px;
                padding: 0 5px;
            }
        }
    }

    /deep/.timerRender{
        width:100%;
        height:100%;
        position: absolute;
        border-radius: 20px;
    }
    /deep/.no-access{
      background-color: #ebeef5 !important;
    }
    /deep/.ag-theme-balham .ag-cell.ag-cell-inline-editing{
        height:100%;
        .ag-input-text-wrapper{
            height:100%;
        }
    }
    /deep/.dayRender {
        background: #68a8e2;
        border-radius: 1.8em;
        -moz-border-radius: 1.8em;
        -webkit-border-radius: 1.8em;
        color: #ffffff;
        display: inline-block;
        font-weight: bold;
        line-height: 3.0em;
        margin-right: 5px;
        text-align: center;
        width: 28px;
        height: 28px;
        font-size: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    /deep/.dayRenderTask {
        border: 3px solid #ddd;
        border-radius: 1.8em;
        -moz-border-radius: 1.8em;
        -webkit-border-radius: 1.8em;
        box-sizing: border-box;
        display: flex;
        justify-content:center;
        align-items:center;
        font-weight: bold;
        line-height: 3.0em;
        margin-right: 5px;
        text-align: center;
        width: 28px;
        height: 28px;
        font-size: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    // GRID END
    .engagement-tooltip-item {
      //line-height: 20px;
      //font-size: 14px;
      font-weight: bold;
      span {
        font-weight: normal;
        margin-left: 10px;
      }
    }
</style>

<style>
    .deleted-modal{
        z-index:999999 !important;
    }
    .hover-over {
        background-color: #e5e5ff;
    }

    .el-tabs--border-card>.el-tabs__content {
        height: 90% !important;
        overflow-y: auto;
    }
    .txtRender {
      color: black !important;
    }
</style>
